"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getGenerateNoNeedForNoiseFunctions;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _utils = require("wapplr/dist/common/utils");
var _getDefaults = require("./getDefaults");
var _color = _interopRequireDefault(require("color"));
var _generateGlasses = _interopRequireDefault(require("./generateGlasses"));
var _generateBinaryWords = _interopRequireDefault(require("./generateBinaryWords"));
// noinspection JSSuspiciousNameCombination

function applyQuaternion(x, y, z, q) {
  var qx = q.x,
    qy = q.y,
    qz = q.z,
    qw = q.w;
  var ix = qw * x + qy * z - qz * y;
  var iy = qw * y + qz * x - qx * z;
  var iz = qw * z + qx * y - qy * x;
  var iw = -qx * x - qy * y - qz * z;
  return {
    x: ix * qw + iw * -qx + iy * -qz - iz * -qy,
    y: iy * qw + iw * -qy + iz * -qx - ix * -qz,
    z: iz * qw + iw * -qz + ix * -qy - iy * -qx
  };
}
function quaternionFromEuler(euler) {
  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "XYZ";
  var x = euler.x,
    y = euler.y,
    z = euler.z;
  var cos = Math.cos;
  var sin = Math.sin;
  var c1 = cos(x / 2);
  var c2 = cos(y / 2);
  var c3 = cos(z / 2);
  var s1 = sin(x / 2);
  var s2 = sin(y / 2);
  var s3 = sin(z / 2);
  var rX, rY, rZ, rW;
  switch (order) {
    case 'XYZ':
      rX = s1 * c2 * c3 + c1 * s2 * s3;
      rY = c1 * s2 * c3 - s1 * c2 * s3;
      rZ = c1 * c2 * s3 + s1 * s2 * c3;
      rW = c1 * c2 * c3 - s1 * s2 * s3;
      break;
    case 'YXZ':
      rX = s1 * c2 * c3 + c1 * s2 * s3;
      rY = c1 * s2 * c3 - s1 * c2 * s3;
      rZ = c1 * c2 * s3 - s1 * s2 * c3;
      rW = c1 * c2 * c3 + s1 * s2 * s3;
      break;
    case 'ZXY':
      rX = s1 * c2 * c3 - c1 * s2 * s3;
      rY = c1 * s2 * c3 + s1 * c2 * s3;
      rZ = c1 * c2 * s3 + s1 * s2 * c3;
      rW = c1 * c2 * c3 - s1 * s2 * s3;
      break;
    case 'ZYX':
      rX = s1 * c2 * c3 - c1 * s2 * s3;
      rY = c1 * s2 * c3 + s1 * c2 * s3;
      rZ = c1 * c2 * s3 - s1 * s2 * c3;
      rW = c1 * c2 * c3 + s1 * s2 * s3;
      break;
    case 'YZX':
      rX = s1 * c2 * c3 + c1 * s2 * s3;
      rY = c1 * s2 * c3 + s1 * c2 * s3;
      rZ = c1 * c2 * s3 - s1 * s2 * c3;
      rW = c1 * c2 * c3 - s1 * s2 * s3;
      break;
    case 'XZY':
      rX = s1 * c2 * c3 - c1 * s2 * s3;
      rY = c1 * s2 * c3 - s1 * c2 * s3;
      rZ = c1 * c2 * s3 + s1 * s2 * c3;
      rW = c1 * c2 * c3 + s1 * s2 * s3;
      break;
    default:
      console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
  }
  return {
    x: rX,
    y: rY,
    z: rZ,
    w: rW
  };
}
function boundingBoxRotatedObject(width, height, depth, rotationVector, rotationOrder) {
  var halfWidth = width / 2;
  var halfHeight = height / 2;
  var halfDepth = depth / 2;
  var cornerPoints = [[-halfWidth, -halfHeight, -halfDepth], [halfWidth, -halfHeight, -halfDepth], [halfWidth, halfHeight, -halfDepth], [-halfWidth, halfHeight, -halfDepth], [-halfWidth, -halfHeight, halfDepth], [halfWidth, -halfHeight, halfDepth], [halfWidth, halfHeight, halfDepth], [-halfWidth, halfHeight, halfDepth]];
  var rotatedPoints = cornerPoints.map(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 3),
      px = _ref2[0],
      py = _ref2[1],
      pz = _ref2[2];
    return applyQuaternion(px, py, pz, quaternionFromEuler(rotationVector, rotationOrder));
  });
  var minX = Number.MAX_VALUE;
  var minY = Number.MAX_VALUE;
  var minZ = Number.MAX_VALUE;
  var maxX = Number.MIN_VALUE;
  var maxY = Number.MIN_VALUE;
  var maxZ = Number.MIN_VALUE;
  for (var i = 0; i < rotatedPoints.length; i++) {
    var point = rotatedPoints[i];
    if (point.x < minX) minX = point.x;
    if (point.x > maxX) maxX = point.x;
    if (point.y < minY) minY = point.y;
    if (point.y > maxY) maxY = point.y;
    if (point.z < minZ) minZ = point.z;
    if (point.z > maxZ) maxZ = point.z;
  }
  return {
    width: maxX - minX,
    height: maxY - minY,
    depth: maxZ - minZ
  };
}
function setNewMinMax(_ref3) {
  var _ref3$mm = _ref3.mm,
    mm = _ref3$mm === void 0 ? {} : _ref3$mm,
    object = _ref3.object,
    p = _ref3.p,
    d = _ref3.d,
    callback = _ref3.callback;
  var min = object.position[p] - object[d] / 2;
  var max = object.position[p] + object[d] / 2;
  if (typeof mm["min" + p] === "undefined" || mm["min" + p] > min) {
    mm["min" + p] = min;
    if (callback) {
      callback({
        type: "min",
        object: object
      });
    }
  }
  if (typeof mm["max" + p] === "undefined" || mm["max" + p] < max) {
    mm["max" + p] = max;
    if (callback) {
      callback({
        type: "max",
        object: object
      });
    }
  }
}
function shiftToCenter(_ref4) {
  var centerX = _ref4.centerX,
    centerY = _ref4.centerY,
    centerZ = _ref4.centerZ,
    generatedMinMax = _ref4.generatedMinMax,
    data = _ref4.data;
  var shiftX = centerX + (generatedMinMax.minx + (generatedMinMax.maxx - generatedMinMax.minx) / 2) * -1;
  var shiftZ = centerY + (generatedMinMax.minz + (generatedMinMax.maxz - generatedMinMax.minz) / 2) * -1;
  var shiftY = centerZ + (generatedMinMax.miny + (generatedMinMax.maxy - generatedMinMax.miny) / 2) * -1;
  data.forEach(function (d) {
    var _d$onClick;
    d.position.x = d.position.x + shiftX;
    d.position.y = d.position.y + shiftY;
    d.position.z = d.position.z + shiftZ;
    if ((_d$onClick = d.onClick) !== null && _d$onClick !== void 0 && _d$onClick.actions) {
      var _d$onClick2;
      (_d$onClick2 = d.onClick) === null || _d$onClick2 === void 0 ? void 0 : _d$onClick2.actions.forEach(function (a) {
        if (a.position) {
          a.position.x = a.position.x + shiftX;
          a.position.y = a.position.y + shiftY;
          a.position.z = a.position.z + shiftZ;
        }
      });
    }
  });
}
function getMinMax(_ref5) {
  var data = _ref5.data;
  var generatedMinMax = {};
  data.forEach(function (object) {
    var objectAfterRotated = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, object), boundingBoxRotatedObject(object.width, object.height, object.depth, object.rotation, object.rotationOrder));
    setNewMinMax({
      mm: generatedMinMax,
      object: objectAfterRotated,
      p: "x",
      d: "width"
    });
    setNewMinMax({
      mm: generatedMinMax,
      object: objectAfterRotated,
      p: "y",
      d: "height"
    });
    setNewMinMax({
      mm: generatedMinMax,
      object: objectAfterRotated,
      p: "z",
      d: "depth"
    });
  });
  return generatedMinMax;
}
function getConnectingObject(_ref6) {
  var start = _ref6.start,
    end = _ref6.end,
    _ref6$axis = _ref6.axis1,
    axis1 = _ref6$axis === void 0 ? "z" : _ref6$axis,
    _ref6$axis2 = _ref6.axis2,
    axis2 = _ref6$axis2 === void 0 ? "y" : _ref6$axis2;
  var dim1 = axis1 === "z" ? "depth" : axis1 === "x" ? "width" : "height";
  var dim2 = axis2 === "z" ? "depth" : axis2 === "x" ? "width" : "height";
  var startZMin = start.position[axis1] - start[dim1] / 2;
  var startZMax = start.position[axis1] + start[dim1] / 2;
  var endZMin = end.position[axis1] - end[dim1] / 2;
  var endZMax = end.position[axis1] + end[dim1] / 2;
  var d1 = Math.abs(startZMin - endZMin);
  var d2 = Math.abs(startZMin - endZMax);
  var d3 = Math.abs(startZMax - endZMin);
  var d4 = Math.abs(startZMax - endZMax);
  var shortest = [[d1, [-1, -1]], [d2, [-1, 1]], [d3, [1, -1]], [d4, [1, 1]]].sort(function (a, b) {
    return a[0] > b[0] ? 1 : a[0] < b[0] ? -1 : 0;
  })[0][1];
  var startZ = start.position[axis1] + shortest[0] * start[dim1] / 2;
  var endZ = end.position[axis1] + shortest[1] * end[dim1] / 2;
  var startMinY = start.position[axis2] - start[dim2] / 2;
  var startMaxY = start.position[axis2] + start[dim2] / 2;
  var endMinY = end.position[axis2] - end[dim2] / 2;
  var endMaxY = end.position[axis2] + end[dim2] / 2;
  var dZ = Math.abs(endZ - startZ);
  var dY = Math.max(Math.abs(endMaxY - startMinY), Math.abs(endMinY - startMaxY));
  var a1 = Math.atan(dY / dZ);
  var c1 = dZ / Math.cos(a1);
  var b1 = Math.asin(start[dim2] / c1);
  var a = a1 - b1;
  var c = Math.cos(b1) * c1;
  var z = (startZ + endZ) / 2;
  var y = (endMinY + startMaxY) / 2;
  return {
    a: start.position[axis2] < end.position[axis2] && startZ < endZ || start.position[axis2] > end.position[axis2] && startZ > endZ ? -a : a,
    c: c,
    z: z,
    y: y
  };
}
function getGenerateNoNeedForNoiseFunctions(_ref7) {
  var shuffleArray = _ref7.shuffleArray,
    getRandomInt = _ref7.getRandomInt,
    generatePropsArray = _ref7.generatePropsArray,
    initialData = _ref7.initialData;
  function generateNoNeedForNoise1(_ref8) {
    var colorScheme = _ref8.colorScheme,
      objectDim = _ref8.objectDim;
    var viewPort = 15 * 1.25;
    var padding = objectDim / viewPort * 2;
    var area = viewPort * (1 - padding * 2);
    var centerX = 0;
    var centerY = 0;
    var centerZ = 0;
    var minX = centerX - area / 2 + objectDim / 2;
    var maxX = centerX + area / 2 - objectDim / 2;
    var minY = centerY - area / 2 + objectDim / 2;
    var maxY = centerY + area / 2 - objectDim / 2;
    //const minZ = centerZ - area / 2 + objectDim / 2;
    //const maxZ = centerZ + area / 2 - objectDim / 2;

    var positions = [{
      x: minX,
      y: maxY,
      z: centerZ
    },
    /*{
        x: minX + (maxX - minX) / 2,
        y: maxY,
        z: centerZ
    },*/
    {
      x: maxX,
      y: maxY,
      z: centerZ
    }, {
      x: maxX,
      y: minY + (maxY - minY) / 2,
      z: centerZ
    }, {
      x: maxX,
      y: minY,
      z: centerZ
    }, {
      x: minX + (maxX - minX) / 2,
      y: minY,
      z: centerZ
    }, {
      x: minX,
      y: minY,
      z: centerZ
    }, {
      x: minX,
      y: minY + (maxY - minY) / 2,
      z: centerZ
    }];
    var objectN = getRandomInt(positions.length / 2, positions.length);
    var cubeI = getRandomInt(0, objectN - 1);
    var cubeDim = objectDim / Math.cos(Math.PI / 4) / 2;
    var windowElementDim = objectDim * Math.cos(Math.PI / 4);
    var coneHeight = Math.min(maxX - centerX, maxY - centerY) / Math.cos(Math.PI / 4) - objectDim / Math.cos(Math.PI / 4) / 2;
    var coneShift = coneHeight / 2 * Math.cos(Math.PI / 4);
    var xConeGeometryProps = [shuffleArray([3, 4])[0]];
    var data = [{
      position: {
        x: minX - viewPort * padding / 2,
        y: centerY,
        z: centerZ
      },
      width: windowElementDim,
      height: viewPort,
      depth: windowElementDim * 5,
      rotation: {
        x: 0,
        y: -45 * Math.PI / 180,
        z: 0
      },
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      nextComposition: {
        rotation: {
          x: 0,
          y: -45 * Math.PI / 180 + 90 * Math.PI / 180,
          z: 0
        }
      },
      animationProps: {
        addObjectsAnimationTime: [3000, 3000]
      }
    }, {
      position: {
        x: maxX + viewPort * padding / 2,
        y: centerY,
        z: centerZ
      },
      width: windowElementDim,
      height: viewPort,
      depth: windowElementDim * 5,
      rotation: {
        x: 0,
        y: 45 * Math.PI / 180,
        z: 0
      },
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      nextComposition: {
        rotation: {
          x: 0,
          y: 45 * Math.PI / 180 - 90 * Math.PI / 180,
          z: 0
        }
      },
      animationProps: {
        addObjectsAnimationTime: [3000, 3000]
      }
    }, {
      position: {
        x: centerX,
        y: minY - viewPort * padding / 2,
        z: centerZ
      },
      width: viewPort,
      height: windowElementDim,
      depth: windowElementDim * 5,
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      },
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      }
    }].concat((0, _toConsumableArray2["default"])(Array(objectN).fill(0).reduce(function (a, _, i) {
      var position = shuffleArray((0, _toConsumableArray2["default"])(positions))[0];
      positions = positions.filter(function (d) {
        return d !== position;
      });
      if (cubeI === i) {
        a.push({
          width: cubeDim,
          height: cubeDim,
          depth: cubeDim,
          position: (0, _objectSpread2["default"])({}, position),
          rotation: {
            x: 0,
            y: 0,
            z: 0
          },
          rotationOrder: "XZY",
          material: {
            color: colorScheme["objectColor" + getRandomInt(1, 3)],
            flatShading: true
          }
        });
        return a;
      }
      var p = {
        width: objectDim,
        height: objectDim / 2,
        depth: objectDim,
        position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
          y: position.y + (objectDim - objectDim / 2) / 2
        }),
        rotation: {
          x: 0,
          y: 0,
          z: 0
        },
        rotationOrder: "XZY",
        material: {
          color: colorScheme["objectColor" + getRandomInt(1, 3)],
          flatShading: true
        },
        geometryType: "cone",
        geometryProps: [getRandomInt(4, 4)],
        nextComposition: {
          rotation: {
            x: 0,
            y: 360 * Math.PI / 180,
            z: 0
          }
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000]
        }
      };
      var bottomHeight = p.height / getRandomInt(1, 2, 3);
      var bottomPosition = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.position), {}, {
        y: p.position.y - p.height / 2 - bottomHeight / 2
      });
      a.push(p, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
        height: bottomHeight,
        rotation: {
          x: 0,
          y: 0,
          z: 180 * Math.PI / 180
        },
        rotationOrder: "XZY",
        position: bottomPosition,
        nextComposition: {
          rotation: {
            x: 0,
            y: -360 * Math.PI / 180,
            z: 180 * Math.PI / 180
          }
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000]
        }
      }));
      return a;
    }, [])), [{
      width: objectDim,
      depth: objectDim,
      height: coneHeight,
      position: {
        x: centerX + coneShift,
        y: centerY + coneShift,
        z: centerZ
      },
      rotation: {
        x: 0,
        y: 0,
        z: -45 * Math.PI / 180
      },
      rotationOrder: "XZY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps
    }, {
      width: objectDim,
      depth: objectDim,
      height: coneHeight,
      position: {
        x: centerX - coneShift,
        y: centerY - coneShift,
        z: centerZ
      },
      rotation: {
        x: 0,
        y: 0,
        z: -225 * Math.PI / 180
      },
      rotationOrder: "XZY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps
    }, {
      width: objectDim,
      depth: objectDim,
      height: coneHeight,
      position: {
        x: centerX - coneShift,
        y: centerY + coneShift,
        z: centerZ
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      rotationOrder: "XZY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps
    }, {
      width: objectDim,
      depth: objectDim,
      height: coneHeight,
      position: {
        x: centerX + coneShift,
        y: centerY - coneShift,
        z: centerZ
      },
      rotation: {
        x: 0,
        y: 0,
        z: 225 * Math.PI / 180
      },
      rotationOrder: "XZY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps
    }]);
    shiftToCenter({
      centerX: centerX,
      centerY: centerY,
      centerZ: centerZ,
      generatedMinMax: getMinMax({
        data: data
      }),
      data: data
    });
    var generatedMinMax = getMinMax({
      data: data
    });
    return {
      generatedData: (0, _toConsumableArray2["default"])(data),
      generatedMinMax: generatedMinMax,
      objectDim: objectDim,
      padding: padding,
      area: area,
      viewPort: viewPort,
      analytics: {}
    };
  }
  function generateNoNeedForNoise2(_ref9) {
    var colorScheme = _ref9.colorScheme,
      objectDim = _ref9.objectDim;
    var viewPort = 15 * 1.25;
    var padding = objectDim * 1.5 / viewPort * 2;
    var area = viewPort * (1 - padding * 2);
    var centerX = 0;
    var centerY = 0;
    var centerZ = 0;
    var minX = centerX - area / 2 + objectDim / 2;
    var maxX = centerX + area / 2 - objectDim / 2;
    var minY = centerY - area / 2 + objectDim / 2;
    var maxY = centerY + area / 2 - objectDim / 2;
    var minZ = centerZ - area / 2 + objectDim / 2;
    var maxZ = centerZ + area / 2 - objectDim / 2;
    var positionsTop = [{
      x: minX,
      y: maxY,
      z: centerZ
    }, {
      x: minX + (maxX - minX) / 2,
      y: maxY,
      z: centerZ
    }, {
      x: maxX,
      y: maxY,
      z: centerZ
    }];
    var positionsLeft = [{
      x: minX,
      y: maxY,
      z: centerZ
    }, {
      x: minX,
      y: centerY,
      z: centerZ
    }, {
      x: minX,
      y: minY,
      z: centerZ
    }];
    var positionsRight = [{
      x: maxX,
      y: maxY,
      z: centerZ
    }, {
      x: maxX,
      y: centerY,
      z: centerZ
    }, {
      x: maxX,
      y: minY,
      z: centerZ
    }];
    var xConeGeometryProps = [shuffleArray([3, 4])[0]];
    var fullWidth = maxX - minX;
    var mainConeHeight = fullWidth / Math.cos(Math.PI / 4);
    var mainConeRotationZ = shuffleArray([45, -45])[0];
    var disableX = mainConeRotationZ === -45 ? maxX : minX;
    var positionsTopRandom = shuffleArray(positionsTop.filter(function (p) {
      return p.x !== disableX;
    }));
    var objectNTop = getRandomInt(positionsTopRandom.length / 2, positionsTopRandom.length);
    var disableY = mainConeRotationZ === -45 ? maxY : maxY;
    var positionsBottomRandom = shuffleArray((0, _toConsumableArray2["default"])((mainConeRotationZ === -45 ? positionsRight : positionsLeft).filter(function (p) {
      return Math.floor(p.y) !== Math.floor(disableY);
    })));
    var objectNBottom = getRandomInt(positionsBottomRandom.length / 2, positionsBottomRandom.length);
    var cubeI = getRandomInt(0, objectNBottom - 1);
    var cubeDim = objectDim / Math.cos(Math.PI / 4) / 2;
    var data = [{
      position: {
        x: centerX,
        y: centerY,
        z: centerZ
      },
      width: viewPort,
      height: viewPort,
      depth: viewPort,
      rotation: {
        x: 0,
        y: 0,
        z: 0
      },
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true,
        opacity: 0
      },
      shadow: {
        disableReceiveShadow: true
      },
      lineProps: {
        disable: true
      }
    }, {
      width: objectDim,
      depth: objectDim,
      height: mainConeHeight,
      position: {
        x: centerX,
        y: centerY,
        z: centerZ
      },
      rotation: {
        x: 0,
        y: 0,
        z: mainConeRotationZ * Math.PI / 180
      },
      rotationOrder: "ZXY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps,
      nextComposition: {
        rotation: {
          x: 0,
          y: -360 * Math.PI / 180,
          z: 0
        }
      }
    }, {
      width: objectDim,
      depth: objectDim,
      height: mainConeHeight,
      position: {
        x: centerX + (mainConeRotationZ === -45) ? -fullWidth / 4 : fullWidth / 4,
        y: centerY - fullWidth / 4,
        z: centerZ - objectDim * 2
      },
      rotation: {
        x: -45 * Math.PI / 180,
        y: 0,
        z: -mainConeRotationZ * Math.PI / 180
      },
      rotationOrder: "ZXY",
      material: {
        color: colorScheme["objectColor" + getRandomInt(1, 3)],
        flatShading: true
      },
      geometryType: "cone",
      geometryProps: xConeGeometryProps,
      nextComposition: {
        rotation: {
          x: 45 * Math.PI / 180,
          y: 360 * Math.PI / 180,
          z: -mainConeRotationZ * Math.PI / 180
        }
      }
    }].concat((0, _toConsumableArray2["default"])(Array(objectNTop).fill(0).reduce(function (a, _, i) {
      var position = positionsTopRandom[i];
      var pNextPos = positionsTopRandom[i + 1] ? (0, _objectSpread2["default"])({}, positionsTopRandom[i + 1]) : (0, _objectSpread2["default"])({}, positionsTopRandom[0]);
      var p = {
        width: objectDim,
        height: objectDim / 2,
        depth: objectDim,
        position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
          y: position.y + (objectDim - objectDim / 2) / 2,
          z: maxZ
        }),
        rotation: {
          x: 0,
          y: 0,
          z: 0
        },
        rotationOrder: "XZY",
        material: {
          color: colorScheme["objectColor" + getRandomInt(1, 3)],
          flatShading: true
        },
        geometryType: "cone",
        geometryProps: [getRandomInt(4, 4)],
        nextComposition: {
          rotation: {
            x: 0,
            y: 360 * Math.PI / 180,
            z: 0
          },
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
            y: position.y + (objectDim - objectDim / 2) / 2,
            z: maxZ
          }, positionsTop.find(function (p) {
            return p.x !== centerX && p.x !== position.x;
          }) ? positionsTop.find(function (p) {
            return p.x !== centerX && p.x !== position.x;
          }) : {}), pNextPos.x !== centerX ? pNextPos : {})
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000]
        }
      };
      var bottomHeight = p.height / getRandomInt(1, 2, 3);
      var bottomPosition = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.position), {}, {
        y: p.position.y - p.height / 2 - bottomHeight / 2
      });
      var bottomPositionNext = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.nextComposition.position), {}, {
        y: p.nextComposition.position.y - p.height / 2 - bottomHeight / 2
      });
      a.push(p, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
        height: bottomHeight,
        rotation: {
          x: 0,
          y: 0,
          z: 180 * Math.PI / 180
        },
        rotationOrder: "XZY",
        position: bottomPosition,
        nextComposition: {
          rotation: {
            x: 0,
            y: -360 * Math.PI / 180,
            z: 180 * Math.PI / 180
          },
          position: bottomPositionNext
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000]
        }
      }));
      return a;
    }, [])), (0, _toConsumableArray2["default"])(Array(objectNBottom).fill(0).reduce(function (a, _, i) {
      var position = positionsBottomRandom[i];
      if (cubeI === i) {
        a.push({
          width: cubeDim,
          height: cubeDim,
          depth: cubeDim,
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
            z: maxZ
          }),
          rotation: {
            x: 0,
            y: 0,
            z: 0
          },
          rotationOrder: "XZY",
          material: {
            color: colorScheme["objectColor" + getRandomInt(1, 3)],
            flatShading: true
          },
          nextComposition: {
            position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, positionsBottomRandom[i + 1] ? (0, _objectSpread2["default"])({}, positionsBottomRandom[i + 1]) : (0, _objectSpread2["default"])({}, positionsBottomRandom[0])), {}, {
              z: maxZ
            })
          },
          animationProps: {
            addObjectsAnimationTime: [6000, 6000]
          }
        });
        return a;
      }
      var p = {
        width: objectDim,
        height: objectDim / 2,
        depth: objectDim,
        position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
          y: position.y + (objectDim - objectDim / 2) / 2
        }),
        rotation: {
          x: 0,
          y: 0,
          z: 0
        },
        rotationOrder: "XZY",
        material: {
          color: colorScheme["objectColor" + getRandomInt(1, 3)],
          flatShading: true
        },
        geometryType: "cone",
        geometryProps: [getRandomInt(4, 4)],
        nextComposition: {
          rotation: {
            x: 0,
            y: 360 * Math.PI / 180,
            z: 0
          },
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, positionsBottomRandom[i + 1] ? (0, _objectSpread2["default"])({}, positionsBottomRandom[i + 1]) : (0, _objectSpread2["default"])({}, positionsBottomRandom[0])), {}, {
            y: positionsBottomRandom[i + 1] ? positionsBottomRandom[i + 1].y + (objectDim - objectDim / 2) / 2 : positionsBottomRandom[0].y + (objectDim - objectDim / 2) / 2
          })
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000],
          easingFunction: "Elastic",
          easingType: "Out"
        }
      };
      var bottomHeight = p.height / getRandomInt(1, 2, 3);
      var bottomPosition = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.position), {}, {
        y: p.position.y - p.height / 2 - bottomHeight / 2
      });
      var bottomPositionNext = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.nextComposition.position), {}, {
        y: p.nextComposition.position.y - p.height / 2 - bottomHeight / 2
      });
      a.push(p, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
        height: bottomHeight,
        rotation: {
          x: 0,
          y: 0,
          z: 180 * Math.PI / 180
        },
        rotationOrder: "XZY",
        position: bottomPosition,
        nextComposition: {
          rotation: {
            x: 0,
            y: -360 * Math.PI / 180,
            z: 180 * Math.PI / 180
          },
          position: bottomPositionNext
        },
        animationProps: {
          addObjectsAnimationTime: [6000, 6000],
          easingFunction: "Elastic",
          easingType: "Out"
        }
      }));
      return a;
    }, [])));
    shiftToCenter({
      centerX: centerX,
      centerY: centerY,
      centerZ: centerZ,
      generatedMinMax: getMinMax({
        data: data
      }),
      data: data
    });
    var generatedMinMax = getMinMax({
      data: data
    });
    return {
      generatedData: (0, _toConsumableArray2["default"])(data),
      generatedMinMax: generatedMinMax,
      objectDim: objectDim,
      padding: padding,
      area: area,
      viewPort: viewPort,
      analytics: {}
    };
  }
  function generateNoNeedForNoise3(_ref10) {
    var colorScheme = _ref10.colorScheme,
      objectDim = _ref10.objectDim,
      licencePlateText = _ref10.licencePlateText;
    var centerX = 0;
    var centerY = 0;
    var centerZ = 0;
    var carWidth = 2.2 * 3;
    var minCarDepth = objectDim === 1.5 ? 5 : objectDim === 1.2 ? 4.5 : 4;
    var maxCarDepth = objectDim === 0.9 ? 5 : objectDim === 1.2 ? 6 : 6.5;
    var carDepth = getRandomInt(minCarDepth * 10, maxCarDepth * 10) / 10 * 3;
    var wheelRadius = 0.713 / 2 * 3;
    var treadWidth = 0.255 * 3;
    var axleRadius = 0.05 * 3;
    var chassisFromY = 0.18 * 3;
    var chassisHeight = 0.05 * 3;
    var section = carDepth / 8;
    var frontAxleZ = centerZ + carDepth / 2 - section * 1.5;
    var backAxleZ = centerZ - carDepth / 2 + section * 1.5;
    var viewPort = carDepth * 1.25;
    var area = carDepth;
    var rotatedObjectDim = objectDim / Math.cos(Math.PI / 4);
    var xConeGeometryProps = [shuffleArray([3, 4])[0]];
    var mainConeHeight = 0.75 * 3;
    var carY = centerY;
    var sideBreak = carY + chassisFromY + chassisHeight / 2 + chassisHeight / 2 + objectDim / 2 + wheelRadius * 2 / 2;
    var shuffledColors = shuffleArray([colorScheme["objectColor1"], colorScheme["objectColor2"], colorScheme["objectColor3"]]);
    var bodyColors = shuffleArray([colorScheme["wallColor"], colorScheme["wallColor2"], colorScheme["objectColor1"], colorScheme["objectColor2"]]);

    /*chassis*/

    var cb1 = {
      width: carWidth - treadWidth,
      height: chassisHeight,
      depth: Math.abs(frontAxleZ - backAxleZ) - wheelRadius * 2,
      position: {
        y: carY + chassisFromY + chassisHeight / 2,
        z: centerZ,
        x: centerX
      }
    };
    var cb2 = {
      width: carWidth - treadWidth * 2 - treadWidth * 2,
      height: chassisHeight,
      depth: chassisHeight * 2,
      position: {
        y: carY + wheelRadius * 2 / 2 + axleRadius * 2 / Math.cos(Math.PI / 4) / 2 + chassisHeight / 2 + chassisHeight - 0.005 * 3,
        z: frontAxleZ,
        x: centerX
      }
    };
    var cb3 = function () {
      var md = getConnectingObject({
        start: cb2,
        end: cb1
      });
      return {
        width: carWidth - treadWidth * 2 - treadWidth * 2,
        height: chassisHeight,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      };
    }();
    var cb4 = {
      width: carWidth - treadWidth * 2 - treadWidth * 2,
      height: chassisHeight,
      depth: chassisHeight * 2,
      position: {
        y: carY + wheelRadius * 2 / 2 + axleRadius * 2 / Math.cos(Math.PI / 4) / 2 + chassisHeight / 2 + chassisHeight - 0.005 * 3,
        z: backAxleZ,
        x: centerX
      }
    };
    var cb5 = function () {
      var md = getConnectingObject({
        start: cb4,
        end: cb1
      });
      return {
        width: carWidth - treadWidth * 2 - treadWidth * 2,
        height: chassisHeight,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      };
    }();
    var cb6 = {
      width: carWidth - treadWidth,
      height: chassisHeight,
      depth: carDepth / 2 - cb1.depth / 2 - wheelRadius * 2,
      position: {
        y: carY + chassisFromY + chassisHeight / 2,
        z: centerZ + carDepth / 2 - (carDepth / 2 - cb1.depth / 2 - wheelRadius * 2) / 2,
        x: centerX
      }
    };
    var cb7 = function () {
      var md = getConnectingObject({
        start: cb2,
        end: cb6
      });
      return {
        width: carWidth - treadWidth * 2 - treadWidth * 2,
        height: chassisHeight,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      };
    }();
    var cb8 = {
      width: carWidth - treadWidth,
      height: chassisHeight,
      depth: carDepth / 2 - cb1.depth / 2 - wheelRadius * 2,
      position: {
        y: carY + chassisFromY + chassisHeight / 2,
        z: centerZ - carDepth / 2 + (carDepth / 2 - cb1.depth / 2 - wheelRadius * 2) / 2,
        x: centerX
      }
    };
    var cb9 = function () {
      var md = getConnectingObject({
        start: cb4,
        end: cb8
      });
      return {
        width: carWidth - treadWidth * 2 - treadWidth * 2,
        height: chassisHeight,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      };
    }();

    /*side plate*/

    var cb10 = {
      width: carWidth - rotatedObjectDim,
      height: objectDim,
      depth: objectDim,
      position: {
        y: sideBreak,
        z: centerZ + carDepth / 2 - rotatedObjectDim / 2,
        x: centerX
      },
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      }
    };
    var cb11 = {
      width: carWidth - rotatedObjectDim,
      height: objectDim,
      depth: objectDim,
      position: {
        y: sideBreak,
        z: centerZ - carDepth / 2 + rotatedObjectDim / 2,
        x: centerX
      },
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      }
    };
    var cb12 = {
      width: objectDim,
      height: objectDim,
      depth: carDepth,
      position: {
        y: sideBreak,
        z: centerZ,
        x: centerX - carWidth / 2 + rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      }
    };
    var cb13 = {
      width: objectDim,
      height: objectDim,
      depth: carDepth,
      position: {
        y: sideBreak,
        z: centerZ,
        x: centerX + carWidth / 2 - rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      }
    };
    var cb14 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb1.depth,
          position: {
            x: cb1.position.x + cb1.width / 2 - chassisHeight / 2,
            y: cb1.position.y,
            z: cb1.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb1.depth,
          position: {
            x: centerX + carWidth / 2 - chassisHeight / 2,
            y: sideBreak,
            z: cb1.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb1.depth,
        position: {
          y: md.y,
          z: cb1.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();
    var cb15 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb6.depth,
          position: {
            x: cb6.position.x + cb6.width / 2 - chassisHeight / 2,
            y: cb6.position.y,
            z: cb6.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb6.depth,
          position: {
            x: centerX + carWidth / 2 - chassisHeight / 2,
            y: sideBreak,
            z: cb6.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb6.depth,
        position: {
          y: md.y,
          z: cb6.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();
    var cb16 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb8.depth,
          position: {
            x: cb8.position.x + cb8.width / 2 - chassisHeight / 2,
            y: cb8.position.y,
            z: cb8.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb8.depth,
          position: {
            x: centerX + carWidth / 2 - chassisHeight / 2,
            y: sideBreak,
            z: cb8.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb8.depth,
        position: {
          y: md.y,
          z: cb8.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();
    var cb17 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb1.depth,
          position: {
            x: cb1.position.x - cb1.width / 2 + chassisHeight / 2,
            y: cb1.position.y,
            z: cb1.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb1.depth,
          position: {
            x: centerX - carWidth / 2 + chassisHeight / 2,
            y: sideBreak,
            z: cb1.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb1.depth,
        position: {
          y: md.y,
          z: cb1.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();
    var cb18 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb6.depth,
          position: {
            x: cb6.position.x - cb6.width / 2 + chassisHeight / 2,
            y: cb6.position.y,
            z: cb6.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb6.depth,
          position: {
            x: centerX - carWidth / 2 + chassisHeight / 2,
            y: sideBreak,
            z: cb6.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb6.depth,
        position: {
          y: md.y,
          z: cb6.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();
    var cb19 = function () {
      var md = getConnectingObject({
        start: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb8.depth,
          position: {
            x: cb8.position.x - cb8.width / 2 + chassisHeight / 2,
            y: cb8.position.y,
            z: cb8.position.z
          }
        },
        end: {
          width: chassisHeight,
          height: chassisHeight,
          depth: cb8.depth,
          position: {
            x: centerX - carWidth / 2 + chassisHeight / 2,
            y: sideBreak,
            z: cb8.position.z
          }
        },
        axis1: "x"
      });
      return {
        width: md.c,
        height: chassisHeight,
        depth: cb8.depth,
        position: {
          y: md.y,
          z: cb8.position.z,
          x: md.z
        },
        rotation: {
          x: 0,
          y: 0,
          z: -md.a
        }
      };
    }();

    /*hood*/

    var hoodDepth = carDepth / 2 - cb1.depth / 2 + section / 3;
    var hoodZ = centerZ + carDepth / 2 - rotatedObjectDim / 2 - hoodDepth / 2;
    var hoodY = sideBreak + rotatedObjectDim / 2 - chassisHeight / 2;
    var needToClickN = getRandomInt(35, 98);
    var cb20 = {
      width: carWidth - rotatedObjectDim,
      height: chassisHeight,
      depth: hoodDepth,
      position: {
        y: hoodY,
        z: hoodZ,
        x: centerX
      },
      onClick: {
        actions: [].concat((0, _toConsumableArray2["default"])(Array(needToClickN - 1).fill(0).map(function (_, i) {
          return {
            nextState: i + 1
          };
        })), [{
          rotation: {
            x: -60 * Math.PI / 180,
            y: 0,
            z: 0
          },
          position: {
            y: hoodY + hoodDepth / 2 * Math.cos(30 * Math.PI / 180),
            z: hoodZ - hoodDepth / 2 + hoodDepth / 2 * Math.sin(30 * Math.PI / 180) + chassisHeight,
            x: centerX
          },
          time: 1000,
          nextState: needToClickN
        }, {
          rotation: {
            x: 0,
            y: 0,
            z: 0
          },
          position: {
            y: hoodY,
            z: hoodZ,
            x: centerX
          },
          time: 1000,
          nextState: 0
        }]),
        state: 0
      }
    };
    var cb21 = {
      width: carWidth - rotatedObjectDim,
      height: chassisHeight,
      depth: section,
      position: {
        y: sideBreak + rotatedObjectDim / 2 - chassisHeight / 2,
        z: centerZ - carDepth / 2 + rotatedObjectDim / 2 + section / 2,
        x: centerX
      }
    };

    /*windscreen*/
    var cb22 = function () {
      var md = getConnectingObject({
        start: {
          width: cb20.width,
          height: chassisHeight,
          depth: chassisHeight,
          position: {
            x: cb20.position.x,
            y: cb20.position.y + cb20.height / 2,
            z: cb20.position.z - cb20.depth / 2
          }
        },
        end: {
          width: cb20.width,
          height: chassisHeight,
          depth: chassisHeight,
          position: {
            x: cb20.position.x,
            y: cb20.position.y + cb20.height / 2 + section / 4 * 3 - chassisHeight / 2,
            z: cb20.position.z - cb20.depth / 2 - section / 4 * 3
          }
        }
      });
      var width = cb20.width - chassisHeight / 2 * 2;
      var height = md.c;
      var glassGeometry = [{
        func: "moveTo",
        props: [0, 0]
      }, {
        func: "lineTo",
        props: [width, 0]
      }, {
        func: "lineTo",
        props: [width, height]
      }, {
        func: "lineTo",
        props: [0, height]
      }, {
        func: "lineTo",
        props: [0, 0]
      }];
      function generateFrame(_ref11) {
        var glassGeometry = _ref11.glassGeometry,
          glassWidth = _ref11.glassWidth,
          glassHeight = _ref11.glassHeight,
          glassDepth = _ref11.glassDepth,
          clampSize = _ref11.clampSize,
          weight = _ref11.weight,
          material = _ref11.material,
          glass = _ref11.glass;
        var frameWidth = glassWidth + weight * 2;
        var frameHeight = glassHeight + weight * 2;
        var frameDepth = glassDepth + weight * 2;
        var scaleXForFrame = frameWidth / glassWidth;
        var scaleYForFrame = frameHeight / glassHeight;
        var frameGeometry = (0, _toConsumableArray2["default"])(glassGeometry.map(function (data) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
            props: [data.props[0] * scaleXForFrame, data.props[1] * scaleYForFrame]
          });
        }));
        var holeWidth = glassWidth - clampSize * 2;
        var holeHeight = glassHeight - clampSize * 2;
        var scaleXForHole = holeWidth / glassWidth;
        var scaleYForHole = holeHeight / glassHeight;
        var holeGeometry = (0, _toConsumableArray2["default"])(glassGeometry.map(function (data) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
            props: [data.props[0] * scaleXForHole + clampSize + weight, data.props[1] * scaleYForHole + clampSize + weight]
          });
        }));
        var scaleXForHole2 = (glassWidth + weight) / glassWidth;
        var scaleYForHole2 = (glassHeight + weight) / glassHeight;
        var frame = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, glass), {}, {
          material: (0, _objectSpread2["default"])({}, material),
          position: {
            x: glass.position.x,
            y: glass.position.y,
            z: glass.position.z
          },
          width: frameWidth,
          height: frameHeight,
          depth: frameDepth,
          geometryType: "extrude",
          geometryProps: [frameGeometry.map(function (p) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
              props: [p.props[0], p.props[1]]
            });
          }), holeGeometry.map(function (p) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
              props: [p.props[0], p.props[1]]
            });
          })],
          shadow: {
            disableReceiveShadow: true
          }
        });
        return [(0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, frame), {}, {
          depth: weight,
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, frame.position), {}, {
            z: glass.position.z + glassDepth / 2 + weight / 2
          })
        }), (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, frame), {}, {
          depth: glassDepth + weight,
          geometryProps: [frameGeometry.map(function (p) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
              props: [p.props[0], p.props[1]]
            });
          }), (0, _toConsumableArray2["default"])(glassGeometry.map(function (data) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, data), {}, {
              props: [data.props[0] * scaleXForHole2 + weight / 2, data.props[1] * scaleYForHole2 + weight / 2]
            });
          })).map(function (p) {
            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
              props: [p.props[0], p.props[1]]
            });
          })],
          material: (0, _objectSpread2["default"])({}, frame.material),
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, frame.position), {}, {
            z: glass.position.z - glassDepth / 2 - weight + (glassDepth + weight) / 2
          })
        })];
      }
      var glass = {
        width: width,
        height: height,
        depth: chassisHeight,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: (90 * Math.PI / 180 - Math.abs(md.a)) * -1,
          y: 0,
          z: 0
        },
        material: {
          color: "#c6e3e3",
          opacity: 0.2,
          transparent: true,
          depthWrite: false
        }
      };
      var frame = generateFrame({
        glassGeometry: glassGeometry,
        glassWidth: width,
        glassHeight: height,
        glassDepth: chassisHeight,
        clampSize: chassisHeight / 4,
        weight: chassisHeight / 2,
        material: {
          color: bodyColors[0]
        },
        glass: glass
      });
      frame.forEach(function (d) {
        var p0 = applyQuaternion(d.position.x - glass.position.x, d.position.y - glass.position.y, d.position.z - glass.position.z, quaternionFromEuler(glass.rotation));
        d.position = {
          x: glass.position.x + p0.x,
          y: glass.position.y + p0.y,
          z: glass.position.z + p0.z
        };
      });
      return [].concat((0, _toConsumableArray2["default"])(frame), [(0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, glass), {}, {
        geometryType: "extrude",
        geometryProps: [glassGeometry]
      })]);
    }();
    var windScreen = (0, _toConsumableArray2["default"])(cb22);

    /*grille*/

    var grille = [{
      width: carWidth,
      height: cb10.position.y - (cb6.position.y + cb6.height / 2),
      depth: chassisHeight,
      position: {
        x: centerX,
        y: (cb10.position.y + (cb6.position.y + cb6.height / 2)) / 2,
        z: cb10.position.z + chassisHeight / 2
      }
    }, {
      width: carWidth,
      height: cb11.position.y - (cb8.position.y + cb8.height / 2),
      depth: chassisHeight,
      position: {
        x: centerX,
        y: (cb11.position.y + (cb8.position.y + cb8.height / 2)) / 2,
        z: cb11.position.z - chassisHeight / 2
      }
    }];
    var licencePlateWidth = 0.53 * 3;
    var licencePlateHeight = 0.13 * 3;
    var licencePlatePadding = licencePlateHeight * 0.2;
    var licencePlateBgColor = (0, _color["default"])(bodyColors[0]).isLight() ? (0, _color["default"])(bodyColors[0]).darken(0.3).hex() : (0, _color["default"])(bodyColors[0]).lighten(0.3).hex();
    var licencePlateTextColor = (0, _color["default"])(licencePlateBgColor).isLight() ? (0, _color["default"])(licencePlateBgColor).darken(0.5).hex() : (0, _color["default"])(licencePlateBgColor).lighten(0.5).hex();
    var licencePlate = (0, _toConsumableArray2["default"])(licencePlateText ? [{
      width: licencePlateWidth,
      height: licencePlateHeight,
      depth: chassisHeight / 4,
      position: {
        x: centerX,
        y: grille[0].position.y - (rotatedObjectDim / 2 - chassisHeight / 2 / Math.cos(Math.PI / 4)) / 2,
        z: grille[0].position.z + grille[0].depth / 2 + chassisHeight / 4 / 2
      },
      material: {
        color: licencePlateBgColor
      }
    }, {
      width: licencePlateWidth - licencePlatePadding * 2,
      height: licencePlateHeight - licencePlatePadding * 2,
      depth: chassisHeight / 8,
      position: {
        x: centerX,
        y: grille[0].position.y - (rotatedObjectDim / 2 - chassisHeight / 2 / Math.cos(Math.PI / 4)) / 2,
        z: grille[0].position.z + grille[0].depth / 2 + chassisHeight / 4 / 2 + chassisHeight / 4 / 2 + chassisHeight / 8 / 2
      },
      geometryType: "text",
      geometryProps: ["/assets/fonts/Noto-Sans-JP_Regular.typeface.json", licencePlateText, "center", [-0.09, 0]],
      material: {
        color: licencePlateTextColor
      },
      lineProps: {
        disable: true
      }
    }, {
      width: licencePlateWidth,
      height: licencePlateHeight,
      depth: chassisHeight / 4,
      position: {
        x: centerX,
        y: grille[1].position.y - (rotatedObjectDim / 2 - chassisHeight / 2 / Math.cos(Math.PI / 4)) / 2,
        z: grille[1].position.z - grille[1].depth / 2 - chassisHeight / 4 / 2
      },
      material: {
        color: licencePlateBgColor
      }
    }, {
      width: licencePlateWidth - licencePlatePadding * 2,
      height: licencePlateHeight - licencePlatePadding * 2,
      depth: chassisHeight / 8,
      position: {
        x: centerX,
        y: grille[1].position.y - (rotatedObjectDim / 2 - chassisHeight / 2 / Math.cos(Math.PI / 4)) / 2,
        z: grille[1].position.z - grille[1].depth / 2 - chassisHeight / 4 / 2 - chassisHeight / 4 / 2 - chassisHeight / 8 / 2
      },
      geometryType: "text",
      geometryProps: ["/assets/fonts/Noto-Sans-JP_Regular.typeface.json", licencePlateText, "center", [-0.09, 0]],
      rotation: {
        x: 0,
        y: 180 * Math.PI / 180,
        z: 0
      },
      material: {
        color: licencePlateTextColor
      },
      lineProps: {
        disable: true
      }
    }] : []);

    /*mirrors*/

    var mirrors = [{
      width: carWidth / 10,
      height: carWidth / 10 / 3 * 2,
      depth: chassisHeight,
      position: {
        x: cb12.position.x - carWidth / 10 / 2,
        y: cb12.position.y + rotatedObjectDim / 2,
        z: cb20.position.z - cb20.depth / 2 - chassisHeight * 2 - chassisHeight / 2
      },
      rotation: {
        x: 0,
        y: -30 * Math.PI / 180,
        z: 0
      }
    }, {
      width: carWidth / 10,
      height: carWidth / 10 / 3 * 2,
      depth: chassisHeight,
      position: {
        x: cb13.position.x + carWidth / 10 / 2,
        y: cb13.position.y + rotatedObjectDim / 2,
        z: cb20.position.z - cb20.depth / 2 - chassisHeight * 2 - chassisHeight / 2
      },
      rotation: {
        x: 0,
        y: 30 * Math.PI / 180,
        z: 0
      }
    }, {
      width: carWidth / 8,
      height: carWidth / 8 / 3,
      depth: chassisHeight,
      position: {
        x: centerX,
        y: windScreen[1].position.y + windScreen[1].height / 2 * Math.sin(Math.abs(windScreen[1].rotation.x)) - carWidth / 8 / 3 / 2 - chassisHeight * 2,
        z: windScreen[1].position.z - windScreen[1].height / 2 * Math.cos(Math.abs(windScreen[1].rotation.x)) + chassisHeight / 2 - chassisHeight / 2
      },
      rotation: {
        x: 0,
        y: -3 * Math.PI / 180,
        z: 0
      }
    }, {
      width: chassisHeight,
      height: chassisHeight * 4,
      depth: chassisHeight / 2,
      position: {
        x: centerX,
        y: windScreen[1].position.y + windScreen[1].height / 2 * Math.sin(Math.abs(windScreen[1].rotation.x)) - chassisHeight * 4 / 2,
        z: windScreen[1].position.z - windScreen[1].height / 2 * Math.cos(Math.abs(windScreen[1].rotation.x)) + chassisHeight / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0
      }
    }];
    var carBody = [cb1, cb2, cb3, cb4, cb5, cb6, cb7, cb8, cb9, cb10, cb11, cb12, cb13, cb14, cb15, cb16, cb17, cb18, cb19, cb20, cb21];

    /*lamps*/

    var lamps = [{
      width: objectDim,
      height: objectDim,
      depth: objectDim / 3,
      position: {
        y: sideBreak,
        z: centerZ + carDepth / 2 + objectDim / 3 / 2,
        x: centerX - carWidth / 2 + rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      material: {
        opacity: 0.7,
        transparent: true,
        depthWrite: false
      },
      shadow: {
        disableReceiveShadow: true
      }
    }, {
      width: objectDim - chassisHeight * 2,
      height: objectDim - chassisHeight * 2,
      depth: objectDim / 3 + chassisHeight / 4,
      position: {
        y: sideBreak,
        z: centerZ + carDepth / 2 + objectDim / 3 / 2,
        x: centerX - carWidth / 2 + rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      shadow: {
        disableReceiveShadow: true
      }
    }, {
      width: objectDim,
      height: objectDim,
      depth: objectDim / 3,
      position: {
        y: sideBreak,
        z: centerZ + carDepth / 2 + objectDim / 3 / 2,
        x: centerX + carWidth / 2 - rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      material: {
        opacity: 0.7,
        transparent: true,
        depthWrite: false
      },
      shadow: {
        disableReceiveShadow: true
      }
    }, {
      width: objectDim - chassisHeight * 2,
      height: objectDim - chassisHeight * 2,
      depth: objectDim / 3 + chassisHeight / 4,
      position: {
        y: sideBreak,
        z: centerZ + carDepth / 2 + objectDim / 3 / 2,
        x: centerX + carWidth / 2 - rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      shadow: {
        disableReceiveShadow: true
      }
    }, {
      width: objectDim,
      height: objectDim,
      depth: objectDim / 3,
      position: {
        y: sideBreak,
        z: centerZ - carDepth / 2 - objectDim / 3 / 2,
        x: centerX - carWidth / 2 + rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      material: {
        opacity: 0.7,
        transparent: true
      }
    }, {
      width: objectDim,
      height: objectDim,
      depth: objectDim / 3,
      position: {
        y: sideBreak,
        z: centerZ - carDepth / 2 - objectDim / 3 / 2,
        x: centerX + carWidth / 2 - rotatedObjectDim / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      },
      material: {
        opacity: 0.7,
        transparent: true
      }
    }];

    /*axles*/

    var axles = [{
      width: carWidth - treadWidth,
      height: axleRadius * 2,
      depth: axleRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: frontAxleZ,
        x: centerX
      },
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      }
    }, {
      width: carWidth - treadWidth,
      height: axleRadius * 2,
      depth: axleRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: backAxleZ,
        x: centerX
      },
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      }
    }, {
      width: axleRadius * 2,
      height: axleRadius * 2,
      depth: Math.abs(frontAxleZ - backAxleZ),
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: centerZ,
        x: centerX
      },
      rotation: {
        x: 0,
        y: 0,
        z: 45 * Math.PI / 180
      }
    }];

    /*wheels*/

    var wheelDim = wheelRadius * 2;
    var wheelSidewallHeight = 0.045 * 3;
    var wheelGeometryProps = [[{
      func: "moveTo",
      props: [0, 0]
    }, {
      func: "lineTo",
      props: [wheelDim, 0]
    }, {
      func: "lineTo",
      props: [wheelDim, wheelDim]
    }, {
      func: "lineTo",
      props: [0, wheelDim]
    }, {
      func: "lineTo",
      props: [0, 0]
    }], [{
      func: "moveTo",
      props: [wheelSidewallHeight, wheelSidewallHeight]
    }, {
      func: "lineTo",
      props: [wheelDim - wheelSidewallHeight, wheelSidewallHeight]
    }, {
      func: "lineTo",
      props: [wheelDim - wheelSidewallHeight, wheelDim - wheelSidewallHeight]
    }, {
      func: "lineTo",
      props: [wheelSidewallHeight, wheelDim - wheelSidewallHeight]
    }, {
      func: "lineTo",
      props: [wheelSidewallHeight, wheelSidewallHeight]
    }]];
    var wheels = [{
      width: wheelRadius * 2,
      height: wheelRadius * 2,
      depth: treadWidth,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: frontAxleZ,
        x: centerX - carWidth / 2 + treadWidth / 2
      },
      rotation: {
        x: 0,
        y: 90 * Math.PI / 180,
        z: 0
      },
      geometryType: "extrude",
      geometryProps: [].concat(wheelGeometryProps)
    }, {
      width: wheelRadius * 2,
      height: treadWidth / 2,
      depth: wheelRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: frontAxleZ,
        x: centerX - carWidth / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 90 * Math.PI / 180
      },
      geometryType: "cone",
      geometryProps: [4]
    }, {
      width: wheelRadius * 2,
      height: wheelRadius * 2,
      depth: treadWidth,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: frontAxleZ,
        x: centerX + carWidth / 2 - treadWidth / 2
      },
      rotation: {
        x: 0,
        y: -90 * Math.PI / 180,
        z: 0
      },
      geometryType: "extrude",
      geometryProps: [].concat(wheelGeometryProps)
    }, {
      width: wheelRadius * 2,
      height: treadWidth / 2,
      depth: wheelRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: frontAxleZ,
        x: centerX + carWidth / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: -90 * Math.PI / 180
      },
      geometryType: "cone",
      geometryProps: [4]
    }, {
      width: wheelRadius * 2,
      height: wheelRadius * 2,
      depth: treadWidth,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: backAxleZ,
        x: centerX - carWidth / 2 + treadWidth / 2
      },
      rotation: {
        x: 0,
        y: 90 * Math.PI / 180,
        z: 0
      },
      geometryType: "extrude",
      geometryProps: [].concat(wheelGeometryProps)
    }, {
      width: wheelRadius * 2,
      height: treadWidth / 2,
      depth: wheelRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: backAxleZ,
        x: centerX - carWidth / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: 90 * Math.PI / 180
      },
      geometryType: "cone",
      geometryProps: [4]
    }, {
      width: wheelRadius * 2,
      height: wheelRadius * 2,
      depth: treadWidth,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: backAxleZ,
        x: centerX + carWidth / 2 - treadWidth / 2
      },
      rotation: {
        x: 0,
        y: -90 * Math.PI / 180,
        z: 0
      },
      geometryType: "extrude",
      geometryProps: [].concat(wheelGeometryProps)
    }, {
      width: wheelRadius * 2,
      height: treadWidth / 2,
      depth: wheelRadius * 2,
      position: {
        y: carY + wheelRadius * 2 / 2,
        z: backAxleZ,
        x: centerX + carWidth / 2
      },
      rotation: {
        x: 0,
        y: 0,
        z: -90 * Math.PI / 180
      },
      geometryType: "cone",
      geometryProps: [4]
    }];
    var passengerAreaDepth = Math.abs(cb20.position.z - cb20.depth / 2 - (cb21.position.z + cb21.depth / 2));
    var passengerAreaWidth = carWidth - rotatedObjectDim * 2;
    var passengerAreaCenterZ = (cb20.position.z - cb20.depth / 2 + (cb21.position.z + cb21.depth / 2)) / 2;

    /*floorplate*/
    var cb23 = {
      width: carWidth - treadWidth * 2,
      height: chassisHeight,
      depth: Math.abs(frontAxleZ - backAxleZ),
      position: {
        y: cb2.position.y + 0.005 * 3,
        z: centerZ,
        x: centerX
      }
    };
    var cb26 = {
      width: cb20.width,
      height: cb20.position.y - cb20.height / 2 - (cb23.position.y + cb23.height / 2),
      depth: chassisHeight,
      position: {
        y: (cb20.position.y - cb20.height / 2 + (cb23.position.y + cb23.height / 2)) / 2,
        z: cb20.position.z - cb20.depth / 2 + objectDim / 2 - chassisHeight / 2 - 0.005 * 3,
        x: centerX
      }
    };
    var cb28 = {
      width: chassisHeight,
      height: cb20.position.y - cb20.height / 2 - (cb23.position.y + cb23.height / 2),
      depth: cb23.depth,
      position: {
        y: (cb20.position.y - cb20.height / 2 + (cb23.position.y + cb23.height / 2)) / 2,
        z: cb23.position.z,
        x: cb12.position.x
      }
    };
    var cb29 = {
      width: chassisHeight,
      height: cb20.position.y - cb20.height / 2 - (cb23.position.y + cb23.height / 2),
      depth: cb23.depth,
      position: {
        y: (cb20.position.y - cb20.height / 2 + (cb23.position.y + cb23.height / 2)) / 2,
        z: cb23.position.z,
        x: cb13.position.x
      }
    };
    var cb30 = {
      width: cb20.width,
      height: cb20.position.y - cb20.height / 2 - (cb23.position.y + cb23.height / 2),
      depth: chassisHeight,
      position: {
        y: (cb20.position.y - cb20.height / 2 + (cb23.position.y + cb23.height / 2)) / 2,
        z: cb23.position.z - cb23.depth / 2 - chassisHeight / 2,
        x: centerX
      }
    };
    var floorPlate = [cb23, cb26, cb29, cb28, cb30];
    var passRotX = 0;

    /*seats*/
    var cb24 = function () {
      var md = getConnectingObject({
        start: {
          width: passengerAreaWidth,
          height: chassisHeight * 3,
          depth: chassisHeight,
          position: {
            x: centerX,
            y: cb23.position.y + cb23.height / 2,
            z: passengerAreaCenterZ + section / 2
          }
        },
        end: {
          width: passengerAreaWidth,
          height: chassisHeight * 3,
          depth: chassisHeight,
          position: {
            x: centerX,
            y: cb23.position.y + cb23.height / 2 + section / 3 * 2,
            z: passengerAreaCenterZ
          }
        }
      });
      passRotX = md.a;
      return [{
        width: passengerAreaWidth,
        height: chassisHeight * 3,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      }, {
        width: passengerAreaWidth,
        height: chassisHeight * 3,
        depth: section / 3,
        position: {
          x: centerX,
          y: cb23.position.y + cb23.height / 2 + chassisHeight * 3 / 2,
          z: passengerAreaCenterZ + section / 2 + Math.cos(passRotX) * (section / 3 * 2) - chassisHeight * 3
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0
        }
      }];
    }();
    var cb25 = function () {
      var md = getConnectingObject({
        start: {
          width: passengerAreaWidth,
          height: chassisHeight * 3,
          depth: chassisHeight,
          position: {
            x: centerX,
            y: cb23.position.y + cb23.height / 2,
            z: passengerAreaCenterZ - passengerAreaDepth / 2 + section / 2
          }
        },
        end: {
          width: passengerAreaWidth,
          height: chassisHeight * 3,
          depth: chassisHeight,
          position: {
            x: centerX,
            y: cb23.position.y + cb23.height / 2 + section / 3 * 2,
            z: passengerAreaCenterZ - passengerAreaDepth / 2
          }
        }
      });
      return [{
        width: passengerAreaWidth,
        height: chassisHeight * 3,
        depth: md.c,
        position: {
          y: md.y,
          z: md.z,
          x: centerX
        },
        rotation: {
          x: md.a,
          y: 0,
          z: 0
        }
      }, {
        width: passengerAreaWidth,
        height: chassisHeight * 3,
        depth: section / 3,
        position: {
          x: centerX,
          y: cb23.position.y + cb23.height / 2 + chassisHeight * 3 / 2,
          z: passengerAreaCenterZ - passengerAreaDepth / 2 + section / 2 + Math.cos(passRotX) * (section / 3 * 2) - chassisHeight * 3
        },
        rotation: {
          x: 0,
          y: 0,
          z: 0
        }
      }];
    }();
    var seats = [].concat((0, _toConsumableArray2["default"])(cb24), (0, _toConsumableArray2["default"])(cb25));
    var passengerPosition = [{
      x: centerX + passengerAreaWidth / 4,
      y: cb23.position.y + cb23.height / 2,
      z: passengerAreaCenterZ + passengerAreaDepth / 4 - Math.cos(passRotX) * (section / 3 * 2),
      _type: "adult"
    }].concat((0, _toConsumableArray2["default"])(getRandomInt(0, 1) === 1 ? [{
      x: centerX - passengerAreaWidth / 4,
      y: cb23.position.y + cb23.height / 2,
      z: passengerAreaCenterZ + passengerAreaDepth / 4 - Math.cos(passRotX) * (section / 3 * 2),
      _type: "adult"
    }] : []), (0, _toConsumableArray2["default"])(getRandomInt(0, 1) === 1 ? [{
      x: centerX - passengerAreaWidth / 4,
      y: cb23.position.y + cb23.height / 2,
      z: passengerAreaCenterZ - passengerAreaDepth / 4 - Math.cos(passRotX) * (section / 3 * 2),
      _type: "child"
    }] : []), (0, _toConsumableArray2["default"])(getRandomInt(0, 1) === 1 ? [{
      x: centerX + passengerAreaWidth / 4,
      y: cb23.position.y + cb23.height / 2,
      z: passengerAreaCenterZ - passengerAreaDepth / 4 - Math.cos(passRotX) * (section / 3 * 2),
      _type: "child"
    }] : []));
    var passengersObjects = (0, _toConsumableArray2["default"])(passengerPosition.reduce(function (a, _ref12) {
      var x = _ref12.x,
        y = _ref12.y,
        z = _ref12.z,
        _type = _ref12._type;
      var position = {
        x: x,
        y: y,
        z: z
      };
      var height = _type === "adult" ? mainConeHeight : mainConeHeight / 3 * 2;
      var positionY = position.y + height / 2;
      a.push({
        width: objectDim,
        depth: objectDim,
        height: height,
        position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
          y: positionY
        }),
        rotation: {
          x: -passRotX / 2,
          y: 0,
          z: 0
        },
        material: {
          color: colorScheme["objectColor" + getRandomInt(1, 3)]
        },
        geometryType: "cone",
        geometryProps: xConeGeometryProps
      });
      var p = {
        width: objectDim,
        height: objectDim / 2,
        depth: objectDim,
        position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, position), {}, {
          z: position.z - Math.cos(passRotX / 2) * (height / 2) + objectDim / 2,
          y: positionY + height / 2 + objectDim / 4
        }),
        material: {
          color: colorScheme["objectColor" + getRandomInt(1, 3)]
        },
        geometryType: "cone",
        geometryProps: [4]
      };
      var bottomHeight = p.height / getRandomInt(1, 2, 3);
      var bottomPosition = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p.position), {}, {
        y: p.position.y - p.height / 2 - bottomHeight / 2
      });
      a.push(p, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
        height: bottomHeight,
        rotation: {
          x: 0,
          y: 0,
          z: 180 * Math.PI / 180
        },
        position: bottomPosition
      }));
      return a;
    }, []));

    /*dashboard*/
    var cb27p = {
      width: carWidth - rotatedObjectDim,
      height: objectDim / 2,
      depth: objectDim,
      position: {
        y: cb20.position.y + cb20.height / 2 - rotatedObjectDim / 2 / 2,
        z: cb20.position.z - cb20.depth / 2,
        x: centerX
      },
      rotation: {
        x: 0,
        y: 0,
        z: 0
      }
    };
    var cb27 = {
      width: carWidth - rotatedObjectDim,
      height: objectDim / 2,
      depth: objectDim / 2,
      position: {
        y: cb27p.position.y + cb27p.height / 2 - rotatedObjectDim / 2 / 2,
        z: cb27p.position.z - cb27p.depth / 2,
        x: centerX
      },
      rotation: {
        x: 45 * Math.PI / 180,
        y: 0,
        z: 0
      }
    };
    var dashboard = [cb27p, cb27, {
      width: chassisHeight,
      height: chassisHeight,
      depth: carDepth / 16,
      position: {
        x: centerX + passengerAreaWidth / 4,
        y: cb27.position.y + chassisHeight,
        z: cb27.position.z - carDepth / 16 / 2
      },
      rotation: {
        x: 15 * Math.PI / 180,
        y: 0,
        z: 0
      }
    }].concat((0, _toConsumableArray2["default"])([{
      width: 0.4 * 3,
      height: 0.4 * 3,
      depth: chassisHeight,
      position: {
        y: cb27.position.y + chassisHeight,
        z: cb27.position.z - carDepth / 16 / 2 - carDepth / 16 / 2 + chassisHeight,
        x: centerX + passengerAreaWidth / 4
      },
      rotation: {
        x: 15 * Math.PI / 180,
        y: 0,
        z: 0
      }
    }].map(function (d) {
      var center = {
        x: centerX + passengerAreaWidth / 4,
        y: cb27.position.y + chassisHeight,
        z: cb27.position.z - carDepth / 16 / 2
      };
      var p0 = applyQuaternion(d.position.x - center.x, d.position.y - center.y, d.position.z - center.z, quaternionFromEuler({
        x: 15 * Math.PI / 180,
        y: 0,
        z: 0
      }));
      d.position = {
        x: center.x + p0.x,
        y: center.y + p0.y,
        z: center.z + p0.z
      };
      return d;
    })));
    var data = [].concat((0, _toConsumableArray2["default"])(carBody.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: bodyColors[0]
      }, d.material ? d.material : {});
      d.editLines = (0, _objectSpread2["default"])({
        disable: true
      }, d.editLines ? d.editLines : {});
      return d;
    })), (0, _toConsumableArray2["default"])(grille.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: bodyColors[0]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(licencePlate), (0, _toConsumableArray2["default"])(mirrors.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: bodyColors[0]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(lamps.map(function (d, i) {
      d.material = (0, _objectSpread2["default"])({
        color: i >= 4 ? colorScheme.lampColor2 : colorScheme.lampColor1
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(axles.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: shuffledColors[1]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(wheels.map(function (d, i) {
      var isG = !(i % 2);
      d.material = (0, _objectSpread2["default"])({
        color: isG ? "#292b2d" : bodyColors[1]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(windScreen), (0, _toConsumableArray2["default"])(floorPlate.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: bodyColors[1]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(seats.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: bodyColors[1]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(dashboard.map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: shuffledColors[2]
      }, d.material ? d.material : {});
      return d;
    })), (0, _toConsumableArray2["default"])(passengersObjects)).map(function (d) {
      d.material = (0, _objectSpread2["default"])({
        color: shuffledColors[0],
        flatShading: true
      }, d.material ? d.material : {});
      d.rotation = (0, _objectSpread2["default"])({
        x: 0,
        y: 0,
        z: 0
      }, d.rotation ? d.rotation : {});
      d.rotationOrder = "XZY";
      return d;
    });

    /*center*/

    shiftToCenter({
      centerX: centerX,
      centerY: centerY,
      centerZ: centerZ,
      generatedMinMax: getMinMax({
        data: data
      }),
      data: data
    });
    data = [{
      position: {
        x: centerX,
        y: centerY,
        z: centerZ
      },
      width: viewPort,
      height: viewPort,
      depth: viewPort,
      rotation: {
        x: 0,
        y: 0,
        z: 0
      },
      material: {
        color: colorScheme["objectColor1"],
        flatShading: true,
        opacity: 0
      },
      shadow: {
        disableReceiveShadow: true
      },
      lineProps: {
        disable: true
      }
    }].concat((0, _toConsumableArray2["default"])(data));
    var generatedMinMax = getMinMax({
      data: data
    });

    /*generative glasses*/

    try {
      var _data;
      var _getGenerateGlassesFu = (0, _generateGlasses["default"])({
          shuffleArray: shuffleArray,
          getRandomInt: getRandomInt,
          initialData: initialData
        }),
        generateCompositionsForGlasses = _getGenerateGlassesFu.generateCompositionsForGlasses;
      var _generateCompositions = generateCompositionsForGlasses(),
        ggData = _generateCompositions.ggData;
      var scaleGlass = 0.1;
      var glassCenterX = (ggData.generatedMinMax.maxx + ggData.generatedMinMax.minx) / 2 * scaleGlass;
      var glassCenterY = (ggData.generatedMinMax.maxy + ggData.generatedMinMax.miny) / 2 * scaleGlass;
      var glassCenterZ = (ggData.generatedMinMax.maxz + ggData.generatedMinMax.minz) / 2 * scaleGlass;
      var glassX = cb23.position.x;
      var glassY = cb23.position.y + cb23.height / 2 + (ggData.generatedMinMax.maxy - ggData.generatedMinMax.miny) / 2 * scaleGlass;
      var glassZ = cb23.position.z + cb23.depth / 2 - (ggData.generatedMinMax.maxz - ggData.generatedMinMax.minz) / 2 * scaleGlass - chassisHeight;
      var glassShiftX = glassX - glassCenterX;
      var glassShiftY = glassY - glassCenterY;
      var glassShiftZ = glassZ - glassCenterZ;
      (_data = data).push.apply(_data, (0, _toConsumableArray2["default"])(ggData.glassesD.map(function (d) {
        var geometryProps = d.geometryProps;
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, d), {}, {
          width: d.width * scaleGlass,
          depth: d.depth * scaleGlass,
          height: d.height * scaleGlass,
          position: {
            x: d.position.x * scaleGlass + glassShiftX,
            y: d.position.y * scaleGlass + glassShiftY,
            z: d.position.z * scaleGlass + glassShiftZ
          }
        }, d.geometryType === "extrude" && geometryProps ? {
          geometryProps: geometryProps.map(function (d) {
            return d.map(function (p) {
              return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
                props: [p.props[0] * scaleGlass, p.props[1] * scaleGlass]
              });
            });
          })
        } : {}), {}, {
          editLines: {
            disable: true
          }
        });
      })));
    } catch (e) {
      console.log("[APP]", e);
    }

    /*binary words*/

    try {
      var addBinaryToLamp = function addBinaryToLamp(_ref13) {
        var _data2;
        var lamp = _ref13.lamp;
        var nullColor = (0, _color["default"])(colorScheme.lampColor2).darken(0.5).hex();
        var binaryData = generateCompositionsForBinaryWords({
          geometryType: "rectangle",
          nullColors: [{
            d: nullColor
          }],
          word: [{
            d: "No need for noise"
          }, {
            d: "Travellers"
          }, {
            d: "Window"
          }, {
            d: "Situations"
          }, {
            d: "Proof of X"
          }, {
            d: "Tokyo"
          }, {
            d: "fxhash"
          }, {
            d: "fxparams"
          }, {
            d: "Generative Glasses"
          }, {
            d: "Binary Words"
          }, {
            d: "C4RC0"
          }, {
            d: "fxrandom"
          }, {
            d: "fxparams"
          }, {
            d: "everyday"
          }, {
            d: "everyone"
          }, {
            d: "generate"
          }, {
            d: "absolute"
          }, {
            d: "gorgeous"
          }, {
            d: "creative"
          }, {
            d: "original"
          }, {
            d: "inspired"
          }, {
            d: "abstract"
          }, {
            d: "geometry"
          }, {
            d: "contrast"
          }, {
            d: "pixelart"
          }, {
            d: "binary01"
          }, {
            d: "interact"
          }, {
            d: "together"
          }, {
            d: "thankyou"
          }, {
            d: "iloveyou"
          }, {
            d: "protocol"
          }, {
            d: "remember"
          }, {
            d: "sequence"
          }, {
            d: "solution"
          }, {
            d: "software"
          }, {
            d: "terminal"
          }, {
            d: "ultimate"
          }, {
            d: "universe"
          }, {
            d: "surprise"
          }, {
            d: "wireless"
          }, {
            d: "reaction"
          }, {
            d: "momentum"
          }, {
            d: "minimize"
          }, {
            d: "interval"
          }, {
            d: "identity"
          }, {
            d: "grateful"
          }, {
            d: "function"
          }, {
            d: "firewall"
          }, {
            d: "exciting"
          }, {
            d: "entrance"
          }, {
            d: "electric"
          }, {
            d: "dynamics"
          }, {
            d: "creation"
          }, {
            d: "colorful"
          }, {
            d: "building"
          }, {
            d: "analysis"
          }, {
            d: "extended"
          }, {
            d: "ideology"
          }, {
            d: "magnetic"
          }, {
            d: "maximize"
          }, {
            d: "personal"
          }, {
            d: "physical"
          }, {
            d: "positive"
          }, {
            d: "pleasure"
          }, {
            d: "possible"
          }, {
            d: "presence"
          }, {
            d: "precious"
          }, {
            d: "pleasant"
          }, {
            d: "simplify"
          }, {
            d: "straight"
          }, {
            d: "symbolic"
          }, {
            d: "yourself"
          }]
        });
        var scaleBinary = lamp.height / 3 * 2 / (binaryData.ggData.generatedMinMax.maxy - binaryData.ggData.generatedMinMax.miny);
        var binaryCenterX = (binaryData.ggData.generatedMinMax.maxx + binaryData.ggData.generatedMinMax.minx) / 2 * scaleBinary;
        var binaryCenterY = (binaryData.ggData.generatedMinMax.maxy + binaryData.ggData.generatedMinMax.miny) / 2 * scaleBinary;
        var binaryCenterZ = (binaryData.ggData.generatedMinMax.maxz + binaryData.ggData.generatedMinMax.minz) / 2 * scaleBinary;
        var binaryX = lamp.position.x;
        var binaryY = lamp.position.y;
        var binaryZ = lamp.position.z - lamp.depth / 2 + chassisHeight / 4 / 2;
        var binaryShiftX = binaryX - binaryCenterX;
        var binaryShiftY = binaryY - binaryCenterY;
        var binaryShiftZ = binaryZ - binaryCenterZ;
        (_data2 = data).push.apply(_data2, (0, _toConsumableArray2["default"])(binaryData.ggData.generatedData.map(function (d) {
          var _d$material, _d$userData;
          var center = {
            x: binaryX,
            y: binaryY,
            z: binaryZ
          };
          var position = {
            x: d.position.x * scaleBinary + binaryShiftX,
            y: d.position.y * scaleBinary + binaryShiftY,
            z: binaryCenterZ + binaryShiftZ
          };
          var p0 = applyQuaternion(position.x - center.x, position.y - center.y, position.z - center.z, quaternionFromEuler({
            x: 0,
            y: 180 * Math.PI / 180,
            z: 45 * Math.PI / 180
          }, "XZY"));
          var geometryProps = d.geometryProps;
          var zS = ((_d$material = d.material) === null || _d$material === void 0 ? void 0 : _d$material.color) === nullColor ? chassisHeight / 4 : (_d$userData = d.userData) !== null && _d$userData !== void 0 && _d$userData.isBinaryData ? chassisHeight / 8 : 0;
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, d), {}, {
            width: d.width * scaleBinary,
            depth: chassisHeight / 4,
            height: d.height * scaleBinary,
            position: {
              x: center.x + p0.x,
              y: center.y + p0.y,
              z: center.z + p0.z - zS
            },
            rotationOrder: "XZY",
            rotation: {
              x: 0,
              y: 180 * Math.PI / 180,
              z: 45 * Math.PI / 180
            }
          }, d.geometryType === "extrude" && geometryProps ? {
            geometryProps: geometryProps.map(function (d) {
              return d.map(function (p) {
                return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
                  props: [p.props[0] * scaleBinary, p.props[1] * scaleBinary]
                });
              });
            })
          } : {}), {}, {
            editLines: {
              disable: true
            },
            animationProps: {
              addObjectsAnimationTime: [2000, 2000]
            }
          });
        })));
      };
      var _getGenerateBinaryWor = (0, _generateBinaryWords["default"])({
          shuffleArray: shuffleArray,
          getRandomInt: getRandomInt,
          generatePropsArray: generatePropsArray,
          initialData: initialData
        }),
        generateCompositionsForBinaryWords = _getGenerateBinaryWor.generateCompositionsForBinaryWords;
      addBinaryToLamp({
        lamp: lamps[4]
      });
      addBinaryToLamp({
        lamp: lamps[5]
      });
    } catch (e) {
      console.log("[APP]", e);
    }
    return {
      generatedData: (0, _toConsumableArray2["default"])(data),
      generatedMinMax: generatedMinMax,
      objectDim: objectDim,
      padding: 0.25,
      area: area,
      viewPort: viewPort,
      analytics: {}
    };
  }
  function generateCompositionsForNoNeedForNoise() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (props.seed) {
      if (props.seed.slice(-4, -1) === "var" && !isNaN(Number(props.seed.slice(-1)))) {
        var n = Number(props.seed.slice(-1));
        (0, _toConsumableArray2["default"])(Array(n).fill(0)).forEach(function () {
          getRandomInt(0, 1);
        });
        console.log("[APP] The random seed moves " + n + " places before starting");
      }
    }
    var generatedDimension = shuffleArray(["landscape4K", "portrait4K", "square4K"])[0];
    var randomVariables = (0, _toConsumableArray2["default"])(Array(100).fill(0).map(function () {
      return getRandomInt(0, 99999) / 100000;
    }));
    var objectDims = [{
      name: "Thin",
      data: {
        Travellers: 0.9,
        Window: 1.2,
        Situations: 1.2
      }
    }, {
      name: "Medium",
      data: {
        Travellers: 1.1,
        Window: 1.4,
        Situations: 1.4
      }
    }, {
      name: "Thick",
      data: {
        Travellers: 1.2,
        Window: 1.6,
        Situations: 1.6
      }
    }];
    var objectDim = shuffleArray(objectDims)[0];
    if (props.objectDim && objectDims.find(function (d) {
      return d.name === props.objectDim;
    })) {
      objectDim = objectDims.find(function (d) {
        return d.name === props.objectDim;
      });
    }
    var colorSchemes = [{
      objectColor1: "#d7b17e",
      objectColor2: "#cac1a6",
      objectColor3: "#c5ac69",
      lampColor1: "#e5bd36",
      lampColor2: "#e04c36",
      wallColor: "#d1a368",
      wallColor2: "#bd853b",
      groundColor: "#dcbb90",
      background: "#a3d0bf",
      borderAndFont: "rgba(29,29,38,0.7)",
      name: "Clean desert"
    }, {
      objectColor1: "#cde0e4",
      objectColor2: "#eddb85",
      objectColor3: "#f7d047",
      lampColor1: "#efc11f",
      lampColor2: "#f74d47",
      wallColor: "#a7e1d3",
      wallColor2: "#c9eee5",
      groundColor: "#8ed9c7",
      background: "#efeacc",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Crystal sea"
    }, {
      objectColor1: "#cde0e4",
      objectColor2: "#eddb85",
      objectColor3: "#d19000",
      lampColor1: "#ecce39",
      lampColor2: "#d15e00",
      wallColor: "#db9796",
      wallColor2: "#d69201",
      groundColor: "#00317d",
      background: "#dcd1e1",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Purple dawn"
    }, {
      objectColor1: "#622628",
      objectColor2: "#ecb908",
      objectColor3: "#12422a",
      lampColor1: "#ecd54e",
      lampColor2: "#cb4a13",
      wallColor: "#186752",
      wallColor2: "#cb6813",
      groundColor: "#0f0c13",
      background: "#1784ad",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Night pasture"
    }, {
      objectColor1: "#2095c8",
      objectColor2: "#f6c803",
      objectColor3: "#44a84d",
      lampColor1: "#e1c240",
      lampColor2: "#d54c1b",
      wallColor: "#f5c906",
      wallColor2: "#723241",
      groundColor: "#1c89ba",
      background: "#aed0c9",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Rapeseed field"
    }, {
      objectColor1: "#d71c23",
      objectColor2: "#85b0de",
      objectColor3: "#eae0a5",
      lampColor1: "#eae0a5",
      lampColor2: "#d71c23",
      wallColor: "#ff7014",
      wallColor2: "#f59bd1",
      groundColor: "#151314",
      background: "#7da9d8",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Blood orange"
    }, {
      objectColor1: "#f2cac9",
      objectColor2: "#5ed0db",
      objectColor3: "#727a85",
      lampColor1: "#ffd822",
      lampColor2: "#f14f14",
      wallColor: "#f3c5c5",
      wallColor2: "#6a3374",
      groundColor: "#141414",
      background: "#71d8e1",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Lavender ice cream"
    }, {
      objectColor1: "#32328c",
      objectColor2: "#f4db5b",
      objectColor3: "#fea001",
      lampColor1: "#ecdc8b",
      lampColor2: "#8a003b",
      wallColor: "#008542",
      wallColor2: "#8a003b",
      groundColor: "#131311",
      background: "#5fd3de",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Royal velvet"
    }, {
      objectColor1: "#01a64a",
      objectColor2: "#ddd2b8",
      objectColor3: "#c7111e",
      lampColor1: "#e7c829",
      lampColor2: "#f13f4b",
      wallColor: "#939099",
      wallColor2: "#eeb6d6",
      groundColor: "#650437",
      background: "#02439d",
      borderAndFont: "rgba(255,255,255,0.7)",
      name: "Rose and gray"
    }];
    var colorScheme = shuffleArray(colorSchemes)[0];
    if (props.colorScheme && colorSchemes.find(function (d) {
      return d.name === props.colorScheme;
    })) {
      colorScheme = colorSchemes.find(function (d) {
        return d.name === props.colorScheme;
      });
    }
    var compositionTypes = [{
      func: generateNoNeedForNoise1,
      name: "Window"
    }, {
      func: generateNoNeedForNoise2,
      name: "Situations"
    }, {
      func: generateNoNeedForNoise3,
      name: "Travellers"
    }];
    var compositionType = shuffleArray(compositionTypes)[0];
    if (props.compositionType && compositionTypes.find(function (d) {
      return d.name === props.compositionType;
    })) {
      compositionType = compositionTypes.find(function (d) {
        return d.name === props.compositionType;
      });
    }
    var rlp1 = getRandomInt(2, 9);
    var rlp2 = getRandomInt(2, 9);
    var rlp3 = getRandomInt(0, 9);
    var rlp4 = getRandomInt(0, 9);
    var rlp_1 = rlp1.toString();
    var rlp_2 = rlp3.toString() + rlp1.toString();
    var rlp_3 = rlp3.toString() + rlp2.toString() + rlp1.toString();
    var rlp_4 = rlp3.toString() + rlp2.toString() + "-" + rlp4.toString() + rlp1.toString();
    var licencePlateTexts = ["C4", "FX", "KL", "東京", "POX", "C4R", "FXH", "KML", "RND", "GEN", "NNN", "C4RC0", "RANDOM", "PROOFOFX", "KUMALEON", "FXHASH", "TRVLLRS"
    /*"Xの証明",
    "プルーフオブ"
    */];

    var randomLicencePlateText = shuffleArray(licencePlateTexts)[0];
    function addEndToLicencePlate(licencePlateText) {
      if (licencePlateText && licencePlateText.length <= 2) {
        licencePlateText = licencePlateText + " " + rlp_4;
      } else if (licencePlateText && licencePlateText.length <= 4) {
        licencePlateText = licencePlateText + "-" + rlp_3;
      } else if (licencePlateText && licencePlateText.length <= 5) {
        licencePlateText = licencePlateText + "-" + rlp_2;
      } else if (licencePlateText) {
        licencePlateText = licencePlateText + "-" + rlp_1;
      }
      return licencePlateText;
    }
    randomLicencePlateText = addEndToLicencePlate(randomLicencePlateText);
    if (props.hash === "tz1PoDdN2oyRyF6DA73zTWAWYhNL4UGr3Egj" || props.hash === "tz1eRhcZff3gwpo8hCacJNnyvgYreFsB6cQZ") {
      randomLicencePlateText = "FXHASH";
    }
    if (props.hash === "tz1QDkAea9R3ChnHFpZQhKshUBvcNRCGooDt") {
      randomLicencePlateText = "KUMALEON";
    }
    if (props.hash === "tz1UJTfbYQWyZBpR5AhfnRDgzcfaSvjfPz3c") {
      randomLicencePlateText = "PROOFOFX";
    }
    var licencePlateText = "";
    try {
      licencePlateText = props.licencePlateText === "random" ? randomLicencePlateText : props.licencePlateText && typeof props.licencePlateText === "string" ? props.licencePlateText : "";
      licencePlateText = licencePlateText.replace(/(?:[\0-\x08\x0E-\x1F!-,\.\/:-@\[-\^`\{-\x9F\xA1-\xA9\xAB-\xB1\xB4\xB6-\xB8\xBB\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u036F\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482-\u0489\u0530\u0557\u0558\u055A-\u055F\u0589-\u05CF\u05EB-\u05EE\u05F3-\u061F\u064B-\u065F\u066A-\u066D\u0670\u06D4\u06D6-\u06E4\u06E7-\u06ED\u06FD\u06FE\u0700-\u070F\u0711\u0730-\u074C\u07A6-\u07B0\u07B2-\u07BF\u07EB-\u07F3\u07F6-\u07F9\u07FB-\u07FF\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u083F\u0859-\u085F\u086B-\u086F\u0888\u088F-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0965\u0970\u0981-\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA-\u09BC\u09BE-\u09CD\u09CF-\u09DB\u09DE\u09E2-\u09E5\u09F2\u09F3\u09FA\u09FB\u09FD-\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A-\u0A58\u0A5D\u0A5F-\u0A65\u0A70\u0A71\u0A75-\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA-\u0ABC\u0ABE-\u0ACF\u0AD1-\u0ADF\u0AE2-\u0AE5\u0AF0-\u0AF8\u0AFA-\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A-\u0B3C\u0B3E-\u0B5B\u0B5E\u0B62-\u0B65\u0B70\u0B78-\u0B82\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BCF\u0BD1-\u0BE5\u0BF3-\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C3E-\u0C57\u0C5B\u0C5C\u0C5E\u0C5F\u0C62-\u0C65\u0C70-\u0C77\u0C7F\u0C81-\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA-\u0CBC\u0CBE-\u0CDC\u0CDF\u0CE2-\u0CE5\u0CF0\u0CF3-\u0D03\u0D0D\u0D11\u0D3B\u0D3C\u0D3E-\u0D4D\u0D4F-\u0D53\u0D57\u0D62-\u0D65\u0D79\u0D80-\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DE5\u0DF0-\u0E00\u0E31\u0E34-\u0E3F\u0E47-\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EB1\u0EB4-\u0EBC\u0EBE\u0EBF\u0EC5\u0EC7-\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F1F\u0F34-\u0F3F\u0F48\u0F6D-\u0F87\u0F8D-\u0FFF\u102B-\u103E\u104A-\u104F\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B-\u1368\u137D-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u1712-\u171E\u1732-\u173F\u1752-\u175F\u176D\u1771-\u177F\u17B4-\u17D6\u17D8-\u17DB\u17DD-\u17DF\u17EA-\u17EF\u17FA-\u180F\u181A-\u181F\u1879-\u187F\u1885\u1886\u18A9\u18AB-\u18AF\u18F6-\u18FF\u191F-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19FF\u1A17-\u1A1F\u1A55-\u1A7F\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1B04\u1B34-\u1B44\u1B4D-\u1B4F\u1B5A-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BFF\u1C24-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C89-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1CFB-\u1CFF\u1DC0-\u1DFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u206F\u2072\u2073\u207A-\u207E\u208A-\u208F\u209D-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A-\u245F\u249C-\u24E9\u2500-\u2775\u2794-\u2BFF\u2CE5-\u2CEA\u2CEF-\u2CF1\u2CF4-\u2CFC\u2CFE\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7F\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF-\u2E2E\u2E30-\u2FFF\u3001-\u3004\u3008-\u3020\u302A-\u3030\u3036\u3037\u303D-\u3040\u3097-\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u3191\u3196-\u319F\u31C0-\u31EF\u3200-\u321F\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA66F-\uA67E\uA69E\uA69F\uA6F0-\uA716\uA720\uA721\uA789\uA78A\uA7CB-\uA7CF\uA7D2\uA7D4\uA7DA-\uA7F1\uA802\uA806\uA80B\uA823-\uA82F\uA836-\uA83F\uA874-\uA881\uA8B4-\uA8CF\uA8DA-\uA8F1\uA8F8-\uA8FA\uA8FC\uA8FF\uA926-\uA92F\uA947-\uA95F\uA97D-\uA983\uA9B3-\uA9CE\uA9DA-\uA9DF\uA9E5\uA9FF\uAA29-\uAA3F\uAA43\uAA4C-\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAC3-\uAADA\uAADE\uAADF\uAAEB-\uAAF1\uAAF5-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABE3-\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB1E\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFE6F\uFE75\uFEFD\uFEFE\uFF00-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD06\uDD34-\uDD3F\uDD79-\uDD89\uDD8C-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEE0\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF76-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC57\uDC77\uDC78\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE01-\uDE0F\uDE14\uDE18\uDE36-\uDE3F\uDE49-\uDE5F\uDE7F\uDEA0-\uDEBF\uDEC8\uDEE5-\uDEEA\uDEF0-\uDEFF\uDF36-\uDF3F\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD24-\uDD2F\uDD3A-\uDE5F\uDE7F\uDEAA-\uDEAF\uDEB2-\uDEFF\uDF28-\uDF2F\uDF46-\uDF50\uDF55-\uDF6F\uDF82-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC00-\uDC02\uDC38-\uDC51\uDC70\uDC73\uDC74\uDC76-\uDC82\uDCB0-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDD02\uDD27-\uDD35\uDD40-\uDD43\uDD45\uDD46\uDD48-\uDD4F\uDD73-\uDD75\uDD77-\uDD82\uDDB3-\uDDC0\uDDC5-\uDDCF\uDDDB\uDDDD-\uDDE0\uDDF5-\uDDFF\uDE12\uDE2C-\uDE3E\uDE41-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEDF-\uDEEF\uDEFA-\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A-\uDF3C\uDF3E-\uDF4F\uDF51-\uDF5C\uDF62-\uDFFF]|\uD805[\uDC35-\uDC46\uDC4B-\uDC4F\uDC5A-\uDC5E\uDC62-\uDC7F\uDCB0-\uDCC3\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDAF-\uDDD7\uDDDC-\uDDFF\uDE30-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEAB-\uDEB7\uDEB9-\uDEBF\uDECA-\uDEFF\uDF1B-\uDF2F\uDF3C-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC2C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD30-\uDD3E\uDD40\uDD42-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD1-\uDDE0\uDDE2\uDDE4-\uDDFF\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE4F\uDE51-\uDE5B\uDE8A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFFF]|\uD807[\uDC09\uDC2F-\uDC3F\uDC41-\uDC4F\uDC6D-\uDC71\uDC90-\uDCFF\uDD07\uDD0A\uDD31-\uDD45\uDD47-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8A-\uDD97\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF3-\uDF01\uDF03\uDF11\uDF34-\uDF4F\uDF5A-\uDFAF\uDFB1-\uDFBF\uDFD5-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD80E-\uD810\uD812-\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD833\uD836\uD83D\uD83F\uD87B-\uD87D\uD87F\uD889-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC40\uDC47-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6F\uDEBF\uDECA-\uDECF\uDEEE-\uDEFF\uDF30-\uDF3F\uDF44-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDE3F\uDE97-\uDEFF\uDF4B-\uDF4F\uDF51-\uDF92\uDFA0-\uDFDF\uDFE2\uDFE4-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFF\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDFFF]|\uD834[\uDC00-\uDEBF\uDED4-\uDEDF\uDEF4-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC00-\uDC2F\uDC6E-\uDCFF\uDD2D-\uDD36\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDE8F\uDEAE-\uDEBF\uDEEC-\uDEEF\uDEFA-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCEC-\uDCEF\uDCFA-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD0-\uDCFF\uDD44-\uDD4A\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCAC\uDCB0\uDCB5-\uDD00\uDD2E\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF3A-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD888[\uDFB0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, '');
      if (!(props.hash === "tz1PoDdN2oyRyF6DA73zTWAWYhNL4UGr3Egj" || props.hash === "tz1S2eKVPGDvA1rS2NCpor5mzbw3HDfvea3S" || props.hash === "tz1eRhcZff3gwpo8hCacJNnyvgYreFsB6cQZ") && licencePlateText && licencePlateText.replace(/\s/g, '').toLowerCase() === "fxhash") {
        licencePlateText = addEndToLicencePlate(licencePlateText);
      }
      if (!(props.hash === "tz1QDkAea9R3ChnHFpZQhKshUBvcNRCGooDt" || props.hash === "tz1S2eKVPGDvA1rS2NCpor5mzbw3HDfvea3S") && licencePlateText && licencePlateText.replace(/\s/g, '').toLowerCase() === "kumaleon") {
        licencePlateText = addEndToLicencePlate(licencePlateText);
      }
      if (!(props.hash === "tz1UJTfbYQWyZBpR5AhfnRDgzcfaSvjfPz3c" || props.hash === "tz1S2eKVPGDvA1rS2NCpor5mzbw3HDfvea3S") && licencePlateText && licencePlateText.replace(/\s/g, '').toLowerCase() === "proofofx") {
        licencePlateText = addEndToLicencePlate(licencePlateText);
      }
      licencePlateText = licencePlateText.toUpperCase();
    } catch (e) {
      console.log("[APP]", "Can't parse licence plate text", e);
    }
    var randomLandscape = shuffleArray(["Horizon 1", "Horizon 2", "Wall 1", "Wall 2"])[0];
    var ggData = compositionType.func({
      colorScheme: colorScheme,
      objectDim: objectDim.data[compositionType.name],
      licencePlateText: licencePlateText
    });
    var startCompIndex = shuffleArray(compositionType.name === "Travellers" ? [{
      d: 0,
      name: "Landing of travellers"
    }, {
      d: 2,
      name: "We are here"
    }, {
      d: 4,
      name: "Last day"
    }] : compositionType.name === "Window" ? [{
      d: 0,
      name: "Open window"
    }
    //{d: 1, name: "Hidden opportunities"},
    ] : [{
      d: 0,
      name: "Before the situation"
    }
    //{d: 1, name: "Together"},
    ])[0];
    var landscape1Bottom = compositionType.name === "Window" ? (ggData.padding * ggData.viewPort + ggData.objectDim / 2) / ggData.viewPort * 100 : (ggData.padding * ggData.viewPort + ggData.objectDim / 2) / ggData.viewPort * 100;
    var landscape2Top = compositionType.name === "Window" ? (ggData.padding * ggData.viewPort + ggData.objectDim / 2 + (ggData.area - ggData.objectDim) - ggData.objectDim / 2) / ggData.viewPort * 100 : compositionType.name === "Travellers" ? 66.6 : (ggData.padding * ggData.viewPort + ggData.objectDim / 2 + (ggData.area - ggData.objectDim) / 2 + ((ggData.area - ggData.objectDim) / 2 - ggData.objectDim / 2) / 2) / ggData.viewPort * 100;
    var landscape2Middle = compositionType.name === "Window" ? 50 : (ggData.padding * ggData.viewPort + ggData.objectDim / 2 + (ggData.area - ggData.objectDim) / 4) / ggData.viewPort * 100;
    var landscape2Bottom = compositionType.name === "Window" ? 100 - landscape2Top + (50 - (100 - landscape2Top)) / 2 : (ggData.padding * ggData.viewPort + ggData.objectDim / 2 + ggData.objectDim / 2 + ((ggData.area - ggData.objectDim) / 4 - ggData.objectDim / 2) / 2) / ggData.viewPort * 100;
    var landscape4Top = compositionType.name === "Window" ? landscape2Top : (ggData.padding * ggData.viewPort + ggData.objectDim / 2 + (ggData.area - ggData.objectDim) / 4 * 3) / ggData.viewPort * 100;
    function add2DPyramid(p) {
      var light = p.light,
        dark = p.dark,
        _p$light = p.light2,
        light2 = _p$light === void 0 ? (0, _color["default"])(light).darken(0.5).hex() : _p$light,
        _p$dark = p.dark2,
        dark2 = _p$dark === void 0 ? (0, _color["default"])(dark).darken(0.5).hex() : _p$dark,
        _p$props = p.props,
        props = _p$props === void 0 ? [] : _p$props,
        _p$centerX = p.centerX,
        centerX = _p$centerX === void 0 ? 0 : _p$centerX,
        _p$centerY = p.centerY,
        centerY = _p$centerY === void 0 ? 0 : _p$centerY,
        width = p.width,
        _p$height = p.height,
        height = _p$height === void 0 ? width : _p$height;
      var startX = centerX - width / 2;
      var startY = centerY - height / 2;
      return [[light].concat((0, _toConsumableArray2["default"])(props), [[[startX, startY], [centerX, centerY], [startX + width, startY], [startX, startY]]]), [light2].concat((0, _toConsumableArray2["default"])(props), [[[startX, startY + height], [centerX, centerY], [startX + width, startY + height], [startX, startY + height]]]), [dark].concat((0, _toConsumableArray2["default"])(props), [[[startX, startY], [centerX, centerY], [startX, startY + height], [startX, startY]]]), [dark2].concat((0, _toConsumableArray2["default"])(props), [[[startX + width, startY], [centerX, centerY], [startX + width, startY + height], [startX + width, startY]]])];
    }
    function add2DPyramid2(p) {
      var light = p.light,
        dark = p.dark,
        _p$light2 = p.light2,
        light2 = _p$light2 === void 0 ? (0, _color["default"])(light).darken(0.5).hex() : _p$light2,
        _p$dark2 = p.dark2,
        dark2 = _p$dark2 === void 0 ? (0, _color["default"])(dark).darken(0.5).hex() : _p$dark2,
        _p$props2 = p.props,
        props = _p$props2 === void 0 ? [] : _p$props2,
        _p$centerX2 = p.centerX,
        centerX = _p$centerX2 === void 0 ? 0 : _p$centerX2,
        _p$centerY2 = p.centerY,
        centerY = _p$centerY2 === void 0 ? 0 : _p$centerY2,
        width = p.width,
        _p$height2 = p.height,
        height = _p$height2 === void 0 ? width : _p$height2,
        _p$shiftX = p.shiftX,
        shiftX = _p$shiftX === void 0 ? 0 : _p$shiftX,
        _p$shiftY = p.shiftY,
        shiftY = _p$shiftY === void 0 ? 0 : _p$shiftY;
      var startX = centerX - width / 2;
      var startY = centerY - height / 2;
      return [[light].concat((0, _toConsumableArray2["default"])(props), [[[centerX, startY], [centerX + shiftX, centerY + shiftY], [startX, centerY], [centerX, startY]]]), [light2].concat((0, _toConsumableArray2["default"])(props), [[[centerX, startY], [centerX + shiftX, centerY + shiftY], [startX + width, centerY], [centerX, startY]]]), [dark].concat((0, _toConsumableArray2["default"])(props), [[[centerX, startY + height], [centerX + shiftX, centerY + shiftY], [startX, centerY], [centerX, startY + height]]]), [dark2].concat((0, _toConsumableArray2["default"])(props), [[[centerX, startY + height], [centerX + shiftX, centerY + shiftY], [startX + width, centerY], [centerX, startY + height]]])];
    }
    var objDimOn2d = ggData.objectDim / ggData.viewPort * 100 / 4 * 3;
    var rObjDimOn2d = ggData.objectDim / ggData.viewPort * 100;
    var landscapes = [{
      name: "Horizon 1",
      dataForCanvas: [{
        type: "rectangle",
        props: [colorScheme.background, 0, Math.min(landscape1Bottom - 5, 20), 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.wallColor, 50, landscape1Bottom, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 100 - landscape1Bottom, Math.min(landscape1Bottom - 5, 20) - 2, 0, 0]
      }, {
        type: "path",
        props: [colorScheme.wallColor, 100 - landscape1Bottom, Math.min(landscape1Bottom - 5, 20) - 2, 0, 0, [[0, -2], [compositionType.name === "Window" ? 50 : 0, 100], [100, -2], [0, -2]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.wallColor2, 50, landscape1Bottom, 0, 0, [[0, 0], [50, -100], [100, 0], [0, 0]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.groundColor, 50, landscape1Bottom, 0, 0, [[66.6, 0], [50, -100], [100, 0], [66.6, 0]]]
      }].concat((0, _toConsumableArray2["default"])(add2DPyramid({
        light: colorScheme.wallColor2,
        dark: colorScheme.wallColor,
        props: [0, 0, 0, 0],
        centerX: compositionType.name === "Window" ? 50 : compositionType.name === "Situations" ? ggData.generatedData[1].rotation.z < 0 ? 100 - (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2,
        centerY: (50 - (100 - landscape1Bottom - 50)) / 2,
        width: objDimOn2d * 2,
        height: objDimOn2d
      }).map(function (props) {
        return {
          type: "pathSquareCenter",
          props: props
        };
      }))),
      dataForBg: [{
        type: "rectangle",
        props: [colorScheme.background, 0, 0, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 50, 0, 0, 0]
      }]
    }, {
      name: "Horizon 2",
      dataForCanvas: [{
        type: "rectangle",
        props: [colorScheme.background, 0, Math.min(landscape2Top - 5, 20), 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 100 - landscape2Top + 5, Math.min(landscape2Top - 5, 20) - 2, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.wallColor, 100 - landscape2Top, landscape2Middle, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.wallColor2, 100 - landscape2Middle - 0.2, landscape2Bottom, 0, 0]
      }, {
        type: compositionType.name === "Window" ? "pathSquareCenter" : "path",
        props: [colorScheme.wallColor2, 100 - landscape2Middle - 0.2, landscape2Bottom, 0, 0, [[0, 100 - 2], [compositionType.name === "Window" ? 50 : 0, 200], [100, 100 - 2], [0, 100 - 2]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.objectColor1, 0, landscape2Top - 0.2, 0, 0, [[0, 100], [50, 50], [100, 100], [0, 100]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.groundColor, 0, landscape2Top - 0.2, 0, 0, [[landscape2Top, 100], [50, 50], [100, 100], [66.6, 100]]]
      }].concat((0, _toConsumableArray2["default"])(add2DPyramid2({
        light: colorScheme.wallColor2,
        dark: colorScheme.groundColor,
        props: [0, 0, 0, 0],
        centerX: compositionType.name === "Window" ? 50 : compositionType.name === "Situations" ? ggData.generatedData[1].rotation.z < 0 ? 100 - (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2,
        centerY: compositionType.name === "Window" ? (100 - landscape2Top) / 4 : (50 - (100 - landscape1Bottom - 50)) / 2,
        width: compositionType.name === "Window" ? rObjDimOn2d / 2 : rObjDimOn2d,
        height: compositionType.name === "Window" ? rObjDimOn2d / 2 : rObjDimOn2d
      }).map(function (props) {
        return {
          type: "pathSquareCenter",
          props: props
        };
      }))),
      dataForBg: [{
        type: "rectangle",
        props: [colorScheme.background, 0, 0, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 50, 0, 0, 0]
      }]
    }, {
      name: "Wall 1",
      dataForCanvas: [{
        type: "rectangleSquareCenter",
        props: [colorScheme.background, 0, 10, 0, Math.min(landscape1Bottom - 5, 20)]
      }, {
        type: "rectangleSquareCenter",
        props: [colorScheme.wallColor, 0, 0, 50, landscape1Bottom]
      }, {
        type: "rectangleSquareCenter",
        props: [colorScheme.groundColor, 0, 10 - 2, 100 - landscape1Bottom, Math.min(landscape1Bottom - 5, 20) - 2]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.wallColor2, 0, 0, 50, landscape1Bottom, [[0, 0], [-100, landscape1Bottom], [-100, 50], [0, 100], [0, 0]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.objectColor2, 0, 0, 50, landscape1Bottom, [[0, 50], [-100, 50], [-100, 100 - landscape1Bottom], [0, 100], [0, 50]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.wallColor2, 0, 0, 0, 50 + (100 - (50 + landscape1Bottom)), [[0, landscape1Bottom], [100 + 2, landscape1Bottom], [100 + 2, 50], [0, 50], [0, landscape1Bottom]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.objectColor2, 0, 0, 0, 50 + (100 - (50 + landscape1Bottom)), [[0, 50], [100 + 2, 50], [100 + 2, 100 - landscape1Bottom], [0, 100 - landscape1Bottom], [0, 50]]]
      }].concat((0, _toConsumableArray2["default"])(add2DPyramid({
        light: colorScheme.wallColor2,
        dark: colorScheme.wallColor,
        props: [0, 0, 0, 0],
        centerX: compositionType.name === "Window" ? 50 : compositionType.name === "Situations" ? ggData.generatedData[1].rotation.z < 0 ? 100 - (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2,
        centerY: compositionType.name === "Window" ? landscape1Bottom : (50 - (100 - landscape1Bottom - 50)) / 2,
        width: compositionType.name === "Window" ? objDimOn2d * 2 : objDimOn2d * 2,
        height: compositionType.name === "Window" ? objDimOn2d * 2 : objDimOn2d
      }).map(function (props) {
        return {
          type: "pathSquareCenter",
          props: props
        };
      }))),
      dataForBg: [{
        type: "rectangle",
        props: [colorScheme.background, 0, 0, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 0, 0, 50 + 2, 0]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.background, 0, 0, 0, Math.min(landscape1Bottom - 5, 20)]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.wallColor, 0, 0, 50, landscape1Bottom]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.groundColor, 0, 0, 100 - landscape1Bottom, Math.min(landscape1Bottom - 5, 20) - 2]
      }, {
        type: "rectangle",
        visibilityStrategy: ["landscape"],
        props: [colorScheme.wallColor2, landscape1Bottom, 50, 0, 50]
      }, {
        type: "rectangle",
        visibilityStrategy: ["landscape"],
        props: [colorScheme.objectColor2, 50, landscape1Bottom, 0, 50]
      }]
    }, {
      name: "Wall 2",
      dataForCanvas: [{
        type: "rectangleSquareCenter",
        props: [colorScheme.background, 0, 10, 0, Math.min(landscape4Top - 5, 20)]
      }, {
        type: "rectangleSquareCenter",
        props: [colorScheme.groundColor, 0, 10 - 2, 50 + 5, Math.min(landscape4Top - 5, 20) - 2]
      }, {
        type: "rectangleSquareCenter",
        props: [colorScheme.wallColor, 0, 0, 50, landscape2Middle]
      }, {
        type: "rectangleSquareCenter",
        props: [colorScheme.wallColor2, 0, 0, 100 - landscape2Middle - 0.2, landscape2Bottom]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.wallColor2, 0, 0, 50, landscape1Bottom, [[0, 0], [-100, landscape1Bottom], [-100, 50], [0, 100], [0, 0]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.objectColor2, 0, 0, 50, landscape1Bottom, [[0, 50], [-100, 50], [-100, 100 - landscape1Bottom], [0, 100], [0, 50]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.wallColor2, 0, 0, 0, 50 + (100 - (50 + landscape1Bottom)), [[0, landscape1Bottom], [100 + 2, landscape1Bottom], [100 + 2, 50], [0, 50], [0, landscape1Bottom]]]
      }, {
        type: "pathSquareCenter",
        props: [colorScheme.objectColor2, 0, 0, 0, 50 + (100 - (50 + landscape1Bottom)), [[0, 50], [100 + 2, 50], [100 + 2, 100 - landscape1Bottom], [0, 100 - landscape1Bottom], [0, 50]]]
      }].concat((0, _toConsumableArray2["default"])(add2DPyramid2({
        light: colorScheme.wallColor2,
        dark: colorScheme.groundColor,
        props: [0, 0, 0, 0],
        centerX: compositionType.name === "Window" ? 50 : compositionType.name === "Situations" ? ggData.generatedData[1].rotation.z < 0 ? 100 - (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2 : (50 - (100 - landscape1Bottom - 50)) / 2,
        centerY: compositionType.name === "Window" ? landscape1Bottom : (50 - (100 - landscape1Bottom - 50)) / 2,
        width: compositionType.name === "Window" ? rObjDimOn2d * 2 : rObjDimOn2d,
        height: compositionType.name === "Window" ? rObjDimOn2d * 2 : rObjDimOn2d
      }).map(function (props) {
        return {
          type: "pathSquareCenter",
          props: props
        };
      }))),
      dataForBg: [{
        type: "rectangle",
        props: [colorScheme.background, 0, 0, 0, 0]
      }, {
        type: "rectangle",
        props: [colorScheme.groundColor, 0, 0, 50 + 2, 0]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.background, 0, 10, 0, Math.min(landscape4Top - 5, 20)]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.groundColor, 0, 10 - 2, 50 + 5, Math.min(landscape4Top - 5, 20) - 2]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.wallColor, 0, 0, 50, landscape2Middle]
      }, {
        type: "rectangle",
        visibilityStrategy: ["portrait"],
        props: [colorScheme.wallColor2, 0, 0, 100 - landscape2Middle - 0.2, landscape2Bottom]
      }, {
        type: "rectangle",
        visibilityStrategy: ["landscape"],
        props: [colorScheme.wallColor2, landscape1Bottom, 50, 0, 50]
      }, {
        type: "rectangle",
        visibilityStrategy: ["landscape"],
        props: [colorScheme.objectColor2, 50, landscape1Bottom, 0, 50]
      }]
    }];
    var landscape = landscapes.find(function (d) {
      return d.name === randomLandscape;
    });
    if (props.background && landscapes.find(function (d) {
      return d.name === props.background;
    })) {
      landscape = landscapes.find(function (d) {
        return d.name === props.background;
      });
    }
    var cameraType = "orthographic";
    //const cameraType = "perspective";
    var fov = 45;
    var scale = 1;
    var objectAngularSize = fov * Math.PI / 180 * scale;
    var distanceToCamera = Math.max(Math.abs(ggData.generatedMinMax.maxy), Math.abs(ggData.generatedMinMax.miny), Math.abs(ggData.generatedMinMax.maxx), Math.abs(ggData.generatedMinMax.minx)) / Math.tan(objectAngularSize / 2);
    var fullWidth = ggData.generatedMinMax.maxx - ggData.generatedMinMax.minx;
    //const fullDepth = ggData.generatedMinMax.maxz - ggData.generatedMinMax.minz;
    var fullHeight = ggData.generatedMinMax.maxy - ggData.generatedMinMax.miny;
    var generatedData = (0, _toConsumableArray2["default"])(ggData.generatedData);
    var compositions = (0, _toConsumableArray2["default"])(initialData.map(function (v) {
      return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, v), {}, {
        data: generatedData
      });
    }));
    compositions[0].background = colorScheme.background;
    compositions[0].randomVariables = randomVariables;
    compositions[0].canvasFullBackground = [].concat((0, _toConsumableArray2["default"])(landscape.dataForBg), [{
      type: "canvas1",
      props: ["rgba(0,0,0,0)", "rgba(0,0,0,0)", ["rgba(0,0,0,0.005)", "rgba(0,0,0,0.01)", "rgba(0,0,0,0.015)"]]
    }, {
      type: "carco",
      visibilityStrategy: ["square"],
      props: [colorScheme.borderAndFont, 2, 2, 2, 2, 10, 5, 10]
    }, {
      type: "carco",
      visibilityStrategy: ["landscape"],
      props: [colorScheme.borderAndFont, 2, 2, 2, 2, 7, 5, 10]
    }, {
      type: "carco",
      visibilityStrategy: ["portrait"],
      props: [colorScheme.borderAndFont, 2, 2, 2, 2, 10, 3, 10]
    }]);
    compositions[0].canvasBackground = [].concat((0, _toConsumableArray2["default"])(landscape.dataForCanvas), [{
      type: "canvas1",
      props: ["rgba(0,0,0,0)", "rgba(0,0,0,0)", ["rgba(0,0,0,0.005)", "rgba(0,0,0,0.01)", "rgba(0,0,0,0.015)"]]
    }]);
    compositions[0].splitScreen = {
      disableChangeSplitScreen: true
    };
    compositions[0].cameraTarget = {
      "x": 0,
      "y": 0,
      "z": 0
    };
    compositions[0].cameraPosition = {
      "x": 0,
      "y": 0,
      "z": ggData.generatedMinMax.maxz + distanceToCamera
    };
    compositions[0].objectsPosition = {
      "x": 0,
      "y": 0,
      "z": 0
    };
    if (cameraType === "orthographic") {
      compositions[0].cameraZoom = 35 * 2 / Math.max(fullWidth / scale, fullHeight / scale);
    }
    compositions[0].objectsRotation = {
      x: 0,
      y: 0,
      z: 0
    };
    compositions[0].controlsProps = (0, _objectSpread2["default"])({
      minPolarAngle: -Math.PI,
      maxPolarAngle: Math.PI,
      minAzimuthAngle: -Math.PI,
      maxAzimuthAngle: Math.PI
    }, compositionType.name === "Travellers" ? {
      enableZoom: true,
      minZoom: compositions[0].cameraZoom,
      maxZoom: compositions[0].cameraZoom * 10
    } : {});
    compositions[0].lights = [{
      x: 20,
      y: 100,
      z: 100,
      type: "Directional",
      props: ["#ffffff", 1.5]
    }, {
      x: -100,
      y: -100,
      z: 100,
      type: "Directional",
      props: ["#ffffff", 0.5]
    }];
    compositions[0].ambientLight = {
      props: ["#ffffff", 1]
    };
    compositions[0].animation = ["D"];
    compositions[0].animationProps = {
      addObjectsAnimationType: "fromCurrentToNext",
      addObjectsAnimationTime: [3000, 6000],
      cameraMoveTime: 5000
    };
    var dimensions = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _getDefaults.defaultDimensions), {}, {
      squareHD: {}
    });
    compositions[0].dimensions = {
      dimensions: Object.keys(dimensions).map(function (key) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, dimensions[key]), {}, {
          key: key
        });
      }),
      defaultDimension: generatedDimension
    };
    compositions[0].data.forEach(function (d) {
      if (d.material.opacity !== 0) {
        d.shadow = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, d.shadow ? d.shadow : {}), {}, {
          disableReceiveShadow: true
        });
      }
    });
    compositions[1] = (0, _utils.copyObject)(compositions[0]);
    compositions[0].data.forEach(function (d) {
      if (d.nextComposition) {
        delete d.nextComposition;
      }
    });
    compositions[1].data.forEach(function (d) {
      if (d.nextComposition) {
        if (d.nextComposition.rotation) {
          d.rotation = (0, _objectSpread2["default"])({}, d.nextComposition.rotation);
        }
        if (d.nextComposition.position) {
          d.position = (0, _objectSpread2["default"])({}, d.nextComposition.position);
        }
        delete d.nextComposition;
      }
    });
    if (compositionType.name === "Travellers") {
      var windowBg = generateNoNeedForNoise1({
        colorScheme: colorScheme,
        objectDim: objectDim.data["Window"]
      });
      var destroy = licencePlateText && licencePlateText.match("DESTROY");
      if (destroy) {
        compositions[0].data = (0, _toConsumableArray2["default"])(compositions[0].data.map(function (d) {
          var _d$rotation;
          if (typeof ((_d$rotation = d.rotation) === null || _d$rotation === void 0 ? void 0 : _d$rotation.y) === "number") {
            d.rotation.y = d.rotation.y + getRandomInt(-15, 15) * Math.PI / 180;
            d.rotation.x = d.rotation.x + getRandomInt(0, 5) * Math.PI / 180;
          }
          return d;
        }));
      }
      compositions[1] = (0, _utils.copyObject)(compositions[0]);
      compositions[2] = (0, _utils.copyObject)(compositions[0]);
      compositions[3] = (0, _utils.copyObject)(compositions[0]);
      compositions[4] = (0, _utils.copyObject)(compositions[0]);
      compositions[5] = (0, _utils.copyObject)(compositions[0]);

      //compositions[0].animation = ["enableFirstAnimation", "D"];

      compositions[0].cameraPosition = {
        "x": 0,
        "y": 0,
        "z": ggData.generatedMinMax.maxz + distanceToCamera
      };
      compositions[0].objectsRotation = {
        "x": 30 * Math.PI / 180,
        "y": -35 * Math.PI / 180,
        "z": 5 * Math.PI / 180
      };
      compositions[0].editLines = {
        show: false,
        disableChangeEditLines: true
      };
      compositions[0].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[0].animationProps), {}, {
        addObjectsAnimationType: "default",
        addObjectsDefaultGoal: 7,
        addObjectsAnimationTime: [1000, 2000],
        cameraMoveTime: 2500,
        waitTimeFinalEnd: 1,
        waitTimeBetweenAnimations: 1,
        waitTimeBeforeAnimation: 1,
        waitTimeBeforeAnimation2: 1

        /*easingFunction: "Exponential",
        easingType: "Out",
        cameraEasingFunction: "Back",
        cameraEasingType: "In",
        objectsEasingFunction: "Back",
        objectsEasingType: "In",*/
      });

      compositions[1].cameraPosition = {
        "x": ggData.generatedMinMax.minx - distanceToCamera,
        "y": 0,
        "z": 0
      };
      compositions[1].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[1].animationProps), {}, {
        addObjectsAnimationTime: [1000, 4000],
        cameraMoveTime: 2000
      });
      compositions[1].editLines = {
        show: true,
        opacityRange: [1, 3]
      };
      compositions[2].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[2].animationProps), {}, {
        addObjectsAnimationType: "default",
        addObjectsDefaultGoal: 3,
        addObjectsAnimationTime: [2000, 4000],
        cameraMoveTime: 2500
      });
      compositions[2].editLines = {
        show: true,
        opacityRange: [5, 10]
      };
      compositions[2].cameraPosition = {
        "x": 0,
        "y": 3,
        "z": ggData.generatedMinMax.maxz + distanceToCamera
      };
      compositions[2].objectsRotation = {
        "x": 0,
        "y": -10 * Math.PI / 180,
        "z": 0
      };
      compositions[2].objectsPosition = {
        "x": 0,
        "y": 0,
        "z": 0
      };
      if (cameraType === "orthographic") {
        compositions[2].cameraZoom = 35 * 2 / (2.2 * 2 * 3 / scale);
      }
      compositions[3].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[3].animationProps), {}, {
        addObjectsAnimationType: "default",
        addObjectsDefaultGoal: 10,
        addObjectsAnimationTime: [1000, 4000],
        cameraMoveTime: 2000
      });
      compositions[3].editLines = {
        show: true,
        opacityRange: [1, 1]
      };
      compositions[3].cameraPosition = {
        "x": 0,
        "y": ggData.generatedMinMax.maxy + distanceToCamera,
        "z": 0
      };
      compositions[4].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[4].animationProps), {}, {
        addObjectsAnimationTime: [1000, 4000],
        cameraMoveTime: 2000
      });
      compositions[4].objectsPosition = {
        "x": 0,
        "y": -1,
        "z": 0
      };
      compositions[4].objectsRotation = {
        "x": 0,
        "y": -190 * Math.PI / 180,
        "z": 0
      };
      compositions[4].cameraPosition = {
        "x": 0,
        "y": 3,
        "z": ggData.generatedMinMax.maxz + distanceToCamera
      };
      if (cameraType === "orthographic") {
        compositions[4].cameraZoom = 35 * 2 / (2.2 * 1.5 * 3 / scale);
      }
      compositions[4].editLines = {
        show: true,
        opacityRange: [1, 1]
      };
      compositions[5].data = [].concat((0, _toConsumableArray2["default"])(compositions[5].data), (0, _toConsumableArray2["default"])(windowBg.generatedData.map(function (d) {
        var center = {
          x: (windowBg.generatedMinMax.maxx + windowBg.generatedMinMax.minx) / 2,
          y: (windowBg.generatedMinMax.maxy + windowBg.generatedMinMax.miny) / 2,
          z: (windowBg.generatedMinMax.maxz + windowBg.generatedMinMax.minz) / 2
        };
        var p0 = applyQuaternion(d.position.x - center.x, d.position.y - center.y, d.position.z - center.z, quaternionFromEuler({
          x: 0,
          y: 180 * Math.PI / 180,
          z: 0
        }));
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, d), {}, {
          rotation: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, d.rotation), {}, {
            y: d.rotation.y + 180 * Math.PI / 180
          }),
          position: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p0), {}, {
            z: p0.z + 15
          }),
          rotationOrder: "YXZ",
          editLines: {
            disable: true
          },
          animationProps: {
            goal: 5000,
            addObjectsAnimationTime: [2500, 2500],
            easingFunction: "Quartic",
            easingType: "InOut"
          }
        });
      })));
      compositions[5].cameraPosition = {
        "x": 0,
        "y": 3,
        "z": ggData.generatedMinMax.maxz + distanceToCamera
      };
      compositions[5].objectsPosition = {
        "x": -18,
        "y": 35,
        "z": -100
      };
      compositions[5].objectsRotation = {
        "x": 35 * Math.PI / 180,
        "y": -160 * Math.PI / 180,
        "z": -15 * Math.PI / 180
      };
      compositions[5].cameraTarget = {
        "x": 0,
        "y": 20,
        "z": -100
      };
      compositions[5].animationProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[5].animationProps), {}, {
        waitTimeFinalEnd: 1,
        waitTimeBetweenAnimations: 1,
        waitTimeBeforeAnimation: 1,
        waitTimeBeforeAnimation2: 1,
        cameraEasingFunction: "Quartic",
        cameraEasingType: "InOut",
        objectsEasingFunction: "Circular",
        objectsEasingType: "In",
        addObjectsAnimationTime: [3000, 5000],
        cameraMoveTime: 2500
      });
      if (cameraType === "orthographic") {
        compositions[5].cameraZoom = 1;
      }
      compositions[5].editLines = {
        show: false,
        disableChangeEditLines: true
      };
      compositions[5].controlsProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, compositions[5].controlsProps), {}, {
        enableZoom: true,
        minZoom: 1,
        maxZoom: 1 * 10
      });
    } else {
      compositions[0].editLines = {
        show: false,
        disableChangeEditLines: true
      };
      compositions[1].editLines = {
        show: false,
        disableChangeEditLines: true
      };
    }
    var copyComp1 = (0, _toConsumableArray2["default"])(compositions);
    var copyComp2 = (0, _toConsumableArray2["default"])(compositions);
    compositions = copyComp1.splice(startCompIndex.d).concat(copyComp2.splice(0, startCompIndex.d));
    var analytics = (0, _objectSpread2["default"])({
      "1. Color scheme": colorScheme.name,
      "2. Composition type": compositionType.name,
      "3. Background": landscape.name,
      "4. Object dimension": objectDim.name,
      "5. Licence plate": compositionType.name === "Travellers" ? licencePlateText || "" : "",
      "6. Start frame": startCompIndex.name,
      "7. Default Aspect Ratio": dimensions[generatedDimension].name
    }, ggData.analytics);
    return {
      compositions: compositions,
      generatedData: generatedData,
      analytics: analytics
    };
  }
  function generateRenderPropsForNoNeedForNoise() {
    return {
      renderType: "WebGL",
      shadow: {
        enable: true,
        opacity: 0.5
      },
      editLines: {
        enable: true
      },
      camera: {
        d: 35,
        fov: 45,
        type: "orthographic"
        //type: "perspective",
      },

      lineProps: {
        opacity: 0.2,
        linewidth: 0.8
      },
      version: "2"
    };
  }
  return {
    generateCompositionsForNoNeedForNoise: generateCompositionsForNoNeedForNoise,
    generateRenderPropsForNoNeedForNoise: generateRenderPropsForNoNeedForNoise
  };
}